'use strict';

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Theme ================*/
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful global functions
 *
 */

/**
 * Initializes the handleize function on the String object.
 * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
 *
 * @private
 * @memberof Utilities
 */
function _handleize() {
  // UTF to ASCII map. Removes accents.
  var defaultDiacriticsRemovalap = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];

  // Generate the diacritics map to replace accented characters.
  var diacriticsMap = {};
  for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
    var letters = defaultDiacriticsRemovalap[i].letters.split("");

    for (var j = 0; j < letters.length; j++) {
      diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
    }
  }

  /**
   * Replaces accented characters with their non-accented counterparts.<br>
   * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
   *
   * @param {boolean} [remove=false] - Whether to remove unicode characters that are not mapped to a non-accented characters.
   *   This includes all non-ascii characters.
   * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
   * @returns {string} String without accents.
   * @memberof Utilities
   * @example
   * // returns 'My accented string$.'
   * 'My áccentéd string$.'.noAccents();
   */
  String.prototype.noAccents = function (remove, replacement) {
    // x00-x7E is the ASCII character range
    var withoutAccents = this.replace(/[^\u0000-\u007E]/g, function (ch) {
      return diacriticsMap[ch] || ch;
    });

    replacement = replacement || '';

    if (remove) {
      withoutAccents = withoutAccents.replace(/[^\u0000-\u007E]/g, replacement);
    }

    return withoutAccents;
  };

  /**
   * Returns a "handleized" version of a string suitable for URLs and file names.<br>
   * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
   *
   * @param {string} [seperator=-] - The character to use as a separator.
   * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
   * @returns {string} The handleized string.
   * @memberof Utilities
   * @example
   * var myString = 'My áccentéd string$.';
   *
   * // returns 'my-accented-string'
   * myString.handleize();
   *
   * // returns 'my_accented_string##'
   * myString.handleize('_', '#');
   */
  String.prototype.handleize = function (separator, replacement) {
    var slug;
    separator = separator || '-';
    replacement = replacement || '';
    slug = this.noAccents(true, replacement).trim().replace(/[^a-z0-9\s-]/ig, replacement).replace(/\s/ig, separator);

    return slug.toLowerCase();
  };
}

_handleize();

theme.utils = {
  // Mimics the Liquid handleize filter in JavaScript
  // requires the stringpos.js library
  handleize: function handleize(str) {
    return str.handleize();
  },

  /**
   * Created an object from a parameter string.
   *
   * @param {string} object_string - The string to parse to an object.
   * @returns {object} The object created from the string.
   * @memberof Utilities
   * @example
   * // If called on a form that takes a name and email, could return { name: "Joe", email: "joe@diffagency.com" }
   * theme.utils.toObject($form.serialize());
   */
  toObject: function toObject(object_string) {
    var parameters = {};
    var elements;

    if (!object_string) {
      return {};
    }

    // Decode the query string to get original characters
    object_string = decodeURIComponent(object_string);

    // Split into each element
    elements = object_string.split('&');

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i].split('=');
      parameters[element[0]] = element[1] || null;
    };

    return parameters;
  },

  /**
   * Extracts the URL parameters into an object.
   *
   * @param {string} [url=window.location.href] - The URL to parse.
   * @returns {object} The query parameters object.
   * @memberof Utilities
   * @example
   * // Returns { name: "Joe", email: "joe@diffagency.com" }
   * theme.utils.getURLParams('https://example.com/?name%3DJoe%26email%3Djoe%40diffagency.com');
   */
  getURLParams: function getURLParams(url) {
    var url = url || window.location.href;
    // Get the string after the '?' from the URL
    var query_string = url.split(/\?([^\#]+)/)[1];

    if (!query_string) {
      return {};
    }

    return this.toObject(query_string);
  },

  setURLParams: function setURLParams(params, options) {
    if (!params) {
      return false;
    }

    var options = options || {};
    options.overwrite = options.overwrite || true;

    var current_params = this.getURLParams();

    var param_keys = Object.keys(params);
    for (var i = 0; i < param_keys.length; i++) {
      var param_key = param_keys[i];
      var param_value = params[param_key];
      current_params[param_key] = !options.overwrite ? current_params[param_key] || param_value : param_value;
    }

    var new_param_keys = Object.keys(current_params);
    var query_array = [];
    for (var i = 0; i < new_param_keys.length; i++) {
      var param_key = new_param_keys[i];
      var param_value = current_params[param_key];
      query_array.push(encodeURIComponent(param_key) + '=' + encodeURIComponent(param_value));
    }

    var query_string = '?' + query_array.join('&');

    if (options.push_state) {
      window.history.pushState({}, null, query_string);
    } else {
      window.history.replaceState({}, null, query_string);
    }
  },

  clearURLParams: function clearURLParams(params, options) {
    var options = options || {};

    if (options.push_state) {
      window.history.pushState({}, null, window.location.pathname);
    } else {
      window.history.replaceState({}, null, window.location.pathname);
    }

    if (params && Object.keys(params).length) {
      // If state was pushed to clear, don't push an extra state
      options.push_state = false;
      this.setURLParams(params, options);
    }
  },

  /**
   * Creates a copy of the passed object.
   *
   * @param {object} obj - The object to clone.
   * @returns Copy of the object passed.
   */
  clone: function clone(obj) {
    if (null == obj || "object" != (typeof obj === 'undefined' ? 'undefined' : _typeof(obj))) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
  },

  /**
   * Curency formating function.
   *
   * @param {(number|string)} price - The price to format.
   * @param {object} options - The options for the currency formatter.
   * @param {boolean} [options.cents=false] - Wether or not the price is currently in cents.
   * @param {string} [options.locale=Shop locale or 'en-CA'] - Override the locale to format to.
   * @param {string} [options.currency=Shop currency or 'CAD'] - Override the currency to output.
   * @param {boolean} [options.no_zeros=false] - To output the price without decimal zeros.
   * @returns {(string|null)} The price formatted based on the locale and currency.
   * @memberof Utilities
   * @example
   * // Returns '$12.56'
   * theme.utils.toMoney(12.56)
   *
   * // Returns '12,56 $'
   * theme.utils.toMoney('12.56', { locale: 'en-CA', currency: 'CAD' })
   *
   * // Returns '$12.56'
   * theme.utils.toMoney('1256', { cents: true })
   */
  toMoney: function toMoney(price, options) {
    if (!price) {
      console.error('Utilities.toMoney: Invalid price passed.', price);
      return null;
    }

    var price = new Number(price);
    var options = options || {};
    var currency_options = {
      style: 'currency'

      // Assign defaults if no options are passed.
    };options.cents = options.cents || false;
    options.locale = options.locale || (theme.shop ? theme.shop.locale : null) || 'en-CA';
    currency_options.currency = options.currency || (theme.shop ? theme.shop.currency : null) || 'CAD';

    // Convert to dollars if the amount passed is in cents
    if (options.cents) {
      price = price / 100;
    }

    // Check if there are decimals and no zero option
    if (options.no_zeros && !price.toString().split('.')[1]) {
      currency_options.minimumSignificantDigits = 2;
    }

    return price.toLocaleString(options.locale, currency_options);
  },

  isEmail: function isEmail(email) {
    return (/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(email)
    );
  }
};

theme.dayMap = {
  "en-CA": {
    "Sunday": "Sun",
    "Monday": "Mon",
    "Tuesday": "Tues",
    "Wednesday": "Wed",
    "Thursday": "Thurs",
    "Friday": "Fri",
    "Saturday": "Sat"
  },
  "fr-CA": {
    "Sunday": "Dim",
    "Monday": "Lun",
    "Tuesday": "Mar",
    "Wednesday": "Mer",
    "Thursday": "Jeu",
    "Friday": "Ven",
    "Saturday": "Sam"
  }
};
$(function () {
  var $navItems = $(".main-nav__list-item");
  var $mainNavContainer = $navItems.parent(".main-nav__list");
  var $submenuNavItems = $(".dropdown_column", $navItems).filter(function () {
    return $(".subsubmenu", this).length > 0;
  });

  $navItems.on("touchstart", function (event) {
    var $thisNavItem = $(this);

    $mainNavContainer.addClass("touch-triggered");

    if ($thisNavItem.hasClass("sub-menu-open")) {
      return true;
    }

    $navItems.removeClass("sub-menu-open");
    $submenuNavItems.removeClass("sub-menu-open");
    $thisNavItem.addClass("sub-menu-open");

    return false;
  });

  $submenuNavItems.on("touchstart", function () {
    var $thisNavItem = $(this);

    $mainNavContainer.addClass("touch-triggered");

    if ($thisNavItem.hasClass("sub-menu-open")) {
      return true;
    }

    $submenuNavItems.removeClass("sub-menu-open");
    $thisNavItem.addClass("sub-menu-open");

    return false;
  });

  $mainNavContainer.on("mousemove", function () {
    $mainNavContainer.removeClass("touch-triggered");
    $navItems.removeClass("sub-menu-open");
    $submenuNavItems.removeClass("sub-menu-open");
  });
});
(function (Modal, $) {

  Modal = function Modal(modal, params) {
    if (!modal) {
      throw new Error('Cannot create modal without an element.');
    }

    var defaults = {
      backdropFadeInDelay: 500,
      backdropFadeOutDelay: 1000,
      backdropOpacity: 0.75,
      backdropSelector: '.modal__backdrop',
      closeEvent: 'click',
      closeSelector: '[data-modal-close]',
      containerFadeInDelay: 500,
      containerFadeOutDelay: 500,
      containerSelector: '.modal__container',
      openStateClass: 'modal--open'
    },
        options = $.extend({}, defaults, params || {});

    var backdrop = modal.querySelector(options.backdropSelector);
    var container = modal.querySelector(options.containerSelector);
    var closers = modal.querySelectorAll(options.closeSelector);

    var showModal = function showModal() {
      modal.classList.add(options.openStateClass);
      $(backdrop).fadeTo(options.backdropFadeInDelay, options.backdropOpacity);
      $(container).fadeIn(options.containerFadeInDelay);
      $(modal).trigger('modal.show');
    };

    var hideModal = function hideModal(event) {
      modal.classList.remove(options.openStateClass);
      $(backdrop).fadeOut(options.backdropFadeOutDelay);
      $(container).fadeOut(options.containerFadeOutDelay);
      $(modal).trigger('modal.hide');
    };

    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener(options.closeEvent, hideModal);
    }

    return {
      show: showModal,
      hide: hideModal
    };
  };

  theme.Modal = Modal;
})(theme.Modal || {}, jQuery);

/* eslint-disable no-param-reassign, func-names, no-use-before-define, no-underscore-dangle */

var PHOTOSWIPE_MARKUP = '\n<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\n  <div class="pswp__bg"></div>\n  <div class="pswp__scroll-wrap">\n    <div class="pswp__container">\n      <div class="pswp__item"></div>\n      <div class="pswp__item"></div>\n      <div class="pswp__item"></div>\n    </div>\n    <div class="pswp__ui pswp__ui--hidden">\n      <div class="pswp__top-bar">\n        <div class="pswp__counter"></div>\n        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n        <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n        <div class="pswp__preloader">\n          <div class="pswp__preloader__icn">\n            <div class="pswp__preloader__cut">\n            <div class="pswp__preloader__donut"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">\n      </button>\n      <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">\n      </button>\n    </div>\n  </div>\n</div>';

function domFragmentFromHtml(html) {
  var range = document.createRange();
  range.selectNode(document.body);
  return range.createContextualFragment(html);
}

// `.pswp__preloader` gets `.pswp__preloader--active` on loading
var photoswipeElement = null;

window.photoswipeDomInit = function () {
  if (photoswipeElement === null) {
    var fragment = domFragmentFromHtml(PHOTOSWIPE_MARKUP);
    photoswipeElement = fragment.firstElementChild;
    document.body.appendChild(fragment);
  }
  return photoswipeElement;
};

/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */

// modified for use for Fashion Nova & YM

window.photoSwipeUI = function (pswp, framework) {
  var ui = this;
  var _overlayUIUpdated = false;
  var _controlsVisible = true;
  var _fullscrenAPI = void 0;
  var _controls = void 0;
  var _indexIndicator = void 0;
  var _initalCloseOnScrollValue = void 0;
  var _isIdle = void 0;
  var _listen = void 0;

  var _loadingIndicator = void 0;
  var _loadingIndicatorHidden = void 0;
  var _loadingIndicatorTimeout = void 0;

  var _galleryHasOneSlide = void 0;

  var _options = void 0;
  var _defaultUIOptions = {
    barsSize: { top: 44, bottom: 'auto' },
    closeElClasses: ['item', 'zoom-wrap', 'ui', 'top-bar'],
    timeToIdle: 4000,
    timeToIdleOutside: 1000,
    loadingIndicatorDelay: 1000, // 2s
    closeEl: true,
    captionEl: false,
    fullscreenEl: true,
    zoomEl: true,
    shareEl: true,
    counterEl: true,
    arrowEl: true,
    preloaderEl: true,

    tapToClose: false,
    tapToToggleControls: true,

    clickToCloseNonZoomable: true,

    indexIndicatorSep: ' / ',
    fitControlsWidth: 1200

  };
  var _blockControlsTap = void 0;

  function _onControlsTap(e) {
    if (!_blockControlsTap) {
      e = e || window.event;

      if (_options.timeToIdle && _options.mouseUsed && !_isIdle) {
        // reset idle timer
        _onIdleMouseMove();
      }

      var target = e.target || e.srcElement;
      var clickedClass = target.getAttribute('class') || '';
      var found = void 0;

      _uiElements.forEach(function (uiElement) {
        if (uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name) > -1) {
          uiElement.onTap();
          found = true;
        }
      });

      if (found) {
        if (e.stopPropagation) {
          e.stopPropagation();
        }
        _blockControlsTap = true;

        setTimeout(function () {
          _blockControlsTap = false;
        }, 30);
      }
    }
  }
  function _fitControlsInViewport() {
    return !pswp.likelyTouchDevice || _options.mouseUsed || window.screen.width > _options.fitControlsWidth;
  }
  function _togglePswpClass(el, cName, add) {
    framework[(add ? 'add' : 'remove') + 'Class'](el, 'pswp__' + cName);
  }

  // add class when there is just one item in the gallery
  // (by default it hides left/right arrows and 1ofX counter)
  function _countNumItems() {
    var hasOneSlide = _options.getNumItemsFn() === 1;

    if (hasOneSlide !== _galleryHasOneSlide) {
      _togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
      _galleryHasOneSlide = hasOneSlide;
    }
  }
  function _hasCloseClass(target) {
    return _options.closeElClasses.some(function (closeElClass) {
      return framework.hasClass(target, 'pswp__' + closeElClass);
    });
  }
  var _idleInterval = void 0;
  var _idleTimer = void 0;
  var _idleIncrement = 0;
  function _onIdleMouseMove() {
    clearTimeout(_idleTimer);
    _idleIncrement = 0;
    if (_isIdle) {
      ui.setIdle(false);
    }
  }
  function _onMouseLeaveWindow(e) {
    e = e || window.event;
    var from = e.relatedTarget || e.toElement;
    if (!from || from.nodeName === 'HTML') {
      clearTimeout(_idleTimer);
      _idleTimer = setTimeout(function () {
        ui.setIdle(true);
      }, _options.timeToIdleOutside);
    }
  }
  function _setupFullscreenAPI() {
    if (_options.fullscreenEl) {
      if (!_fullscrenAPI) {
        _fullscrenAPI = ui.getFullscreenAPI();
      }
      if (_fullscrenAPI) {
        framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
        ui.updateFullscreen();
        framework.addClass(pswp.template, 'pswp--supports-fs');
      } else {
        framework.removeClass(pswp.template, 'pswp--supports-fs');
      }
    }
  }
  function _setupLoadingIndicator() {
    // Setup loading indicator
    if (_options.preloaderEl) {
      _toggleLoadingIndicator(true);

      _listen('beforeChange', function () {
        clearTimeout(_loadingIndicatorTimeout);

        // display loading indicator with delay
        _loadingIndicatorTimeout = setTimeout(function () {
          if (pswp.currItem && pswp.currItem.loading) {
            if (!pswp.allowProgressiveImg() || pswp.currItem.img && !pswp.currItem.img.naturalWidth) {
              // show preloader if progressive loading is not enabled,
              // or image width is not defined yet (because of slow connection)
              _toggleLoadingIndicator(false);
              // items-controller.js function allowProgressiveImg
            }
          } else {
            _toggleLoadingIndicator(true); // hide preloader
          }
        }, _options.loadingIndicatorDelay);
      });
      _listen('imageLoadComplete', function (index, item) {
        if (pswp.currItem === item) {
          _toggleLoadingIndicator(true);
        }
      });
    }
  }
  function _toggleLoadingIndicator(hide) {
    if (_loadingIndicatorHidden !== hide) {
      _togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
      _loadingIndicatorHidden = hide;
    }
  }
  function _applyNavBarGaps(item) {
    var gap = item.vGap;

    if (_fitControlsInViewport()) {
      var bars = _options.barsSize;

      // height of top bar is static, no need to calculate it
      gap.top = bars.top;
      gap.bottom = bars.top; // keep things centered
    } else {
      gap.top = 0;
      gap.bottom = 0;
    }
  }
  function _setupIdle() {
    // Hide controls when mouse is used
    if (_options.timeToIdle) {
      _listen('mouseUsed', function () {
        framework.bind(document, 'mousemove', _onIdleMouseMove);
        framework.bind(document, 'mouseout', _onMouseLeaveWindow);

        _idleInterval = setInterval(function () {
          _idleIncrement += 1;
          if (_idleIncrement === 2) {
            ui.setIdle(true);
          }
        }, _options.timeToIdle / 2);
      });
    }
  }
  function _setupHidingControlsDuringGestures() {
    // Hide controls on vertical drag
    _listen('onVerticalDrag', function (now) {
      if (_controlsVisible && now < 0.95) {
        ui.hideControls();
      } else if (!_controlsVisible && now >= 0.95) {
        ui.showControls();
      }
    });

    // Hide controls when pinching to close
    var pinchControlsHidden = void 0;
    _listen('onPinchClose', function (now) {
      if (_controlsVisible && now < 0.9) {
        ui.hideControls();
        pinchControlsHidden = true;
      } else if (pinchControlsHidden && !_controlsVisible && now > 0.9) {
        ui.showControls();
      }
    });

    _listen('zoomGestureEnded', function () {
      pinchControlsHidden = false;
      if (pinchControlsHidden && !_controlsVisible) {
        ui.showControls();
      }
    });
  }

  var _uiElements = [{
    name: 'button--zoom',
    option: 'zoomEl',
    onTap: pswp.toggleDesktopZoom
  }, {
    name: 'counter',
    option: 'counterEl',
    onInit: function onInit(el) {
      _indexIndicator = el;
    }
  }, {
    name: 'button--close',
    option: 'closeEl',
    onTap: pswp.close
  }, {
    name: 'button--arrow--left',
    option: 'arrowEl',
    onTap: pswp.prev
  }, {
    name: 'button--arrow--right',
    option: 'arrowEl',
    onTap: pswp.next
  }, {
    name: 'button--fs',
    option: 'fullscreenEl',
    onTap: function onTap() {
      if (_fullscrenAPI.isFullscreen()) {
        _fullscrenAPI.exit();
      } else {
        _fullscrenAPI.enter();
      }
    }
  }, {
    name: 'preloader',
    option: 'preloaderEl',
    onInit: function onInit(el) {
      _loadingIndicator = el;
    }
  }];

  function _setupUIElements() {
    var classAttr = void 0;

    function loopThroughChildElements(sChildren) {
      if (!sChildren) {
        return;
      }

      [].concat(_toConsumableArray(sChildren)).forEach(function (item) {
        classAttr = item.className;

        _uiElements.forEach(function (uiElement) {
          if (classAttr.indexOf('pswp__' + uiElement.name) > -1) {
            if (_options[uiElement.option]) {
              // if element is not disabled from options
              framework.removeClass(item, 'pswp__element--disabled');
              if (uiElement.onInit) {
                uiElement.onInit(item);
              }

              // item.style.display = 'block';
            } else {
              framework.addClass(item, 'pswp__element--disabled');
              // item.style.display = 'none';
            }
          }
        });
      });
    }
    loopThroughChildElements(_controls.children);

    var topBar = framework.getChildByClass(_controls, 'pswp__top-bar');
    if (topBar) {
      loopThroughChildElements(topBar.children);
    }
  }

  ui.init = function () {
    // extend options
    framework.extend(pswp.options, _defaultUIOptions, true);

    // create local link for fast access
    _options = pswp.options;

    // find pswp__ui element
    _controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');

    // create local link
    _listen = pswp.listen;

    _setupHidingControlsDuringGestures();

    // update controls when slides change
    _listen('beforeChange', ui.update);

    // toggle zoom on double-tap
    _listen('doubleTap', function (point) {
      var initialZoomLevel = pswp.currItem.initialZoomLevel;

      if (pswp.getZoomLevel() !== initialZoomLevel) {
        pswp.zoomTo(initialZoomLevel, point, 333);
      } else {
        pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
      }
    });

    // bind events for UI
    _listen('bindEvents', function () {
      framework.bind(_controls, 'pswpTap click', _onControlsTap);
      framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);

      if (!pswp.likelyTouchDevice) {
        framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
      }
    });

    // unbind events for UI
    _listen('unbindEvents', function () {
      if (_idleInterval) {
        clearInterval(_idleInterval);
      }
      framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
      framework.unbind(document, 'mousemove', _onIdleMouseMove);
      framework.unbind(_controls, 'pswpTap click', _onControlsTap);
      framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
      framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);

      if (_fullscrenAPI) {
        framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
        if (_fullscrenAPI.isFullscreen()) {
          _options.hideAnimationDuration = 0;
          _fullscrenAPI.exit();
        }
        _fullscrenAPI = null;
      }
    });

    // clean up things when gallery is destroyed
    _listen('destroy', function () {
      framework.removeClass(_controls, 'pswp__ui--over-close');
      framework.addClass(_controls, 'pswp__ui--hidden');
      ui.setIdle(false);
    });

    if (!_options.showAnimationDuration) {
      framework.removeClass(_controls, 'pswp__ui--hidden');
    }
    _listen('initialZoomIn', function () {
      if (_options.showAnimationDuration) {
        framework.removeClass(_controls, 'pswp__ui--hidden');
      }
    });
    _listen('initialZoomOut', function () {
      framework.addClass(_controls, 'pswp__ui--hidden');
    });

    _listen('parseVerticalMargin', _applyNavBarGaps);

    _setupUIElements();

    _countNumItems();

    _setupIdle();

    _setupFullscreenAPI();

    _setupLoadingIndicator();
  };

  ui.setIdle = function (isIdle) {
    _isIdle = isIdle;
    _togglePswpClass(_controls, 'ui--idle', isIdle);
  };

  ui.update = function () {
    // Don't update UI if it's hidden
    if (_controlsVisible && pswp.currItem) {
      ui.updateIndexIndicator();
      _overlayUIUpdated = true;
    } else {
      _overlayUIUpdated = false;
    }

    _countNumItems();
  };

  ui.updateFullscreen = function (e) {
    if (e) {
      // some browsers change window scroll position during the fullscreen
      // so PhotoSwipe updates it just in case
      setTimeout(function () {
        pswp.setScrollOffset(0, framework.getScrollY());
      }, 50);
    }

    // toogle pswp--fs class on root element
    framework[(_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class'](pswp.template, 'pswp--fs');
  };

  ui.updateIndexIndicator = function () {
    if (_options.counterEl) {
      _indexIndicator.innerHTML = pswp.getCurrentIndex() + 1 + _options.indexIndicatorSep + _options.getNumItemsFn();
    }
  };

  ui.onGlobalTap = function (e) {
    e = e || window.event;
    var target = e.target || e.srcElement;

    if (_blockControlsTap) {
      return;
    }

    if (e.detail && e.detail.pointerType === 'mouse') {
      // close gallery if clicked outside of the image
      if (_hasCloseClass(target)) {
        pswp.close();
        return;
      }

      if (framework.hasClass(target, 'pswp__img')) {
        if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
          if (_options.clickToCloseNonZoomable) {
            pswp.close();
          }
        } else {
          pswp.toggleDesktopZoom(e.detail.releasePoint);
        }
      }
    } else {
      // tap anywhere (except buttons) to toggle visibility of controls
      if (_options.tapToToggleControls) {
        if (_controlsVisible) {
          ui.hideControls();
        } else {
          ui.showControls();
        }
      }

      // tap to close gallery
      if (_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target))) {
        pswp.close();
      }
    }
  };
  ui.onMouseOver = function (e) {
    e = e || window.event;
    var target = e.target || e.srcElement;

    // add class when mouse is over an element that should close the gallery
    _togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
  };

  ui.hideControls = function () {
    framework.addClass(_controls, 'pswp__ui--hidden');
    _controlsVisible = false;
  };

  ui.showControls = function () {
    _controlsVisible = true;
    if (!_overlayUIUpdated) {
      ui.update();
    }
    framework.removeClass(_controls, 'pswp__ui--hidden');
  };

  ui.supportsFullscreen = function () {
    var d = document;
    return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
  };

  ui.getFullscreenAPI = function () {
    var dE = document.documentElement;
    var api = void 0;
    var tF = 'fullscreenchange';

    if (dE.requestFullscreen) {
      api = {
        enterK: 'requestFullscreen',
        exitK: 'exitFullscreen',
        elementK: 'fullscreenElement',
        eventK: tF
      };
    } else if (dE.mozRequestFullScreen) {
      api = {
        enterK: 'mozRequestFullScreen',
        exitK: 'mozCancelFullScreen',
        elementK: 'mozFullScreenElement',
        eventK: 'moz' + tF
      };
    } else if (dE.webkitRequestFullscreen) {
      api = {
        enterK: 'webkitRequestFullscreen',
        exitK: 'webkitExitFullscreen',
        elementK: 'webkitFullscreenElement',
        eventK: 'webkit' + tF
      };
    } else if (dE.msRequestFullscreen) {
      api = {
        enterK: 'msRequestFullscreen',
        exitK: 'msExitFullscreen',
        elementK: 'msFullscreenElement',
        eventK: 'MSFullscreenChange'
      };
    }

    if (api) {
      api.enter = function () {
        // disable close-on-scroll in fullscreen
        _initalCloseOnScrollValue = _options.closeOnScroll;
        _options.closeOnScroll = false;

        if (this.enterK === 'webkitRequestFullscreen') {
          pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
        } else {
          return pswp.template[this.enterK]();
        }
        return null;
      };
      api.exit = function () {
        _options.closeOnScroll = _initalCloseOnScrollValue;

        return document[this.exitK]();
      };
      api.isFullscreen = function () {
        return document[this.elementK];
      };
    }

    return api;
  };
};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = 'js-focus-hidden';

    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
  }
};

(function ($) {

  var settings = {
    bagels: true,
    moneyFormat: window.theme.moneyFormat,
    freeShippingThreshold: window.theme.freeShippingThreshold,
    shippingRate: window.theme.shippingRate
  };

  var cart = new function () {
    function Cart(settings) {

      var lang = theme.cart_lang;
      var money_format = lang === 'fr' ? "{{amount}} $" : "${{amount}}";

      this.defaults = {
        selectors: {
          cartOpen: ".js-cart-open",
          cartClose: ".js-cart-close",
          cartItems: ".js-cart-items",
          cartItemsCount: ".js-cart-item-count",
          cartItemDelete: ".js-item-delete",
          cartTotal: ".js-cart-total",
          cartDiscounts: ".js-cart-discounts",
          cartDiscountsTotal: ".js-cart-discounts-total",
          cartFreeShippingDifference: ".js-cart-shipping-difference",
          cartItem: ".js-cart-item",
          cartItemMinus: ".js-cart-minus",
          cartItemQty: ".js-cart-qty",
          cartItemPlus: ".js-cart-plus",
          cartShippingRate: ".js-cart-shipping",
          cartStyleParent: "body", // Container to hold action styling
          cartFlyout: "#cart-flyout"
        },
        classes: {
          cartOpened: "cart__open",
          itemDisabled: "disabled",
          freeShipping: "cart__free-shipping",
          cartEmpty: "cart__empty"
        },
        itemData: {
          id: "item-id"
        },
        moneyFormat: money_format,
        freeShippingThreshold: 5000,
        shippingRate: 500
      };

      this.options = $.extend(this.defaults, settings);

      this.$cartStyleParent = $(this.options.selectors.cartStyleParent);
      this.$cartItemsCount = $(this.options.selectors.cartItemsCount);
      this.$cartItems = $(this.options.selectors.cartItems);
      this.$cartFlyout = $(this.options.selectors.cartFlyout);
      this.itemQuantities = {};

      this.initDynamicSelectors();

      this.init();
    }

    Cart.prototype.initDynamicSelectors = function () {
      var _ = this;

      _.$cartTotal = $(_.options.selectors.cartTotal);
      _.$cartDiscounts = $(_.options.selectors.cartDiscounts);
      _.$cartDiscountsTotal = $(_.options.selectors.cartDiscountsTotal);
      _.$cartFreeShippingDifference = $(_.options.selectors.cartFreeShippingDifference);
      _.$cartShippingRate = $(_.options.selectors.cartShippingRate);
      _.$cartShippingRate.html(_.formatMoney(_.options.shippingRate));
      _.$cartCloseButton = $(_.options.selectors.cartClose);

      // Adds cart-close functionality when cart-flyout is rebuild
      _.$cartCloseButton.on('click', function (event) {
        event.preventDefault();
        _.$cartStyleParent.removeClass(_.options.classes.cartOpened);
      });
    };

    Cart.prototype.init = function () {
      var _ = this;
      $(_.options.selectors.cartOpen).on('click', function (event) {
        event.preventDefault();
        _.openCart();
      });

      $(_.options.selectors.cartClose).on('click', function (event) {
        event.preventDefault();
        _.$cartStyleParent.removeClass(_.options.classes.cartOpened);
      });

      _.updateCartInfo();
      //_.refreshFlyout(document._shopify_cart.cart);

      if (window.theme.template.name == 'cart') {
        _.openCart();
      }
    };

    Cart.prototype.lockCart = function () {
      this.$cartFlyout.css('pointer-events', 'none');
    };

    Cart.prototype.unlockCart = function () {
      this.$cartFlyout.css('pointer-events', 'auto');
    };

    Cart.prototype.refreshFlyout = function (data, outerpromise) {
      var _ = this;
      var promise = outerpromise || $.Deferred();

      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
        data = JSON.parse(data);
      }

      data.items = data.items || data.line_items;

      $.get('/cart?view=flyout', function (resp) {
        _.$cartFlyout.html(resp);

        _.initDynamicSelectors();
        _.setSubTotal(data);

        _.itemQuantities = {};

        $('.cart__item').each(function () {
          var element = {
            id: $(this).data('item-id'),
            quantity: $(this).find('.js-cart-qty').val(),
            variant_id: $(this).data('item-variant-id')
          };
          _.initItem($(this), element, false);
        });

        $(document).trigger('cart.qty_update');

        promise.resolve();
      }).fail(function () {
        promise.reject();
      });

      // Update empty cart state
      if (data.items.length > 0) {
        _.$cartStyleParent.removeClass(_.options.classes.cartEmpty);
      } else {
        _.$cartStyleParent.addClass(_.options.classes.cartEmpty);
      }

      var item_ids = document._shopify_cart.cart.line_items.map(function (item) {
        return item.product_id;
      });

      $('[data-cart-badge]').find('.badge-cart').remove();
      $.each(item_ids, function (index, id) {
        $('[data-cart-badge="' + id + '"]').append('<img class="product-badge badge-cart" src="' + window.theme.badges.cart + '">');
      });

      _.setCartCount(data);
      _.unlockCart();

      return promise;
    };

    Cart.prototype.updateCartInfo = function () {
      var promise = document._shopify_cart._refresh();
      document._shopify_cart._run_campaigns();
      return promise;
    };

    Cart.prototype.setCartCount = function (data) {
      var _ = this;
      _.$cartItemsCount.html(data.item_count);
    };

    Cart.prototype.setSubTotal = function (data) {
      var _ = this;

      var shippingDifference = _.options.freeShippingThreshold - data.total_price;
      var shippingCost = _.options.shippingRate;
      var has_discounts = !!data.total_discount && data.total_discount > 0;

      _.$cartFreeShippingDifference.html(_.formatMoney(shippingDifference));

      if (shippingDifference > 0) {
        _.$cartStyleParent.removeClass(_.options.classes.freeShipping);
      } else {
        _.$cartStyleParent.addClass(_.options.classes.freeShipping);
        shippingCost = 0;
      }

      _.$cartTotal.html(_.formatMoney(data.total_price + shippingCost));
      _.$cartDiscounts.toggleClass('has-discounts', has_discounts);

      if (has_discounts) {
        _.$cartDiscountsTotal.html(_.formatMoney(data.total_discount));
      }
    };

    Cart.prototype.setItemQty = function ($qty, qty) {
      $qty.val(qty);
    };

    Cart.prototype.initItem = function (item, itemData, prepend) {
      var _ = this;

      var $item = $(item);
      var id = itemData.id;
      var variantId = itemData.variant_id;
      var $qty = $(_.options.selectors.cartItemQty, $item);

      $(_.options.selectors.cartItemDelete, $item).on("click", function (event) {
        _.lockCart();
        _.deleteItem(id, $item);
      });

      _.setItemQty($qty, itemData.quantity);

      var min = parseInt($qty.attr('min'));
      var max = parseInt($qty.attr('max'));

      $(_.options.selectors.cartItemPlus, $item).on("click", function (event) {
        _.lockCart();
        _.updateQuantity(parseInt($qty.val()) + 1, id, $qty, $item, min, max);
      });

      $(_.options.selectors.cartItemMinus, $item).on("click", function (event) {
        _.lockCart();
        _.updateQuantity(parseInt($qty.val()) - 1, id, $qty, $item, min, max);
      });

      $(_.options.selectors.cartItemQty, $item).on("cart.quantity-change change", function (event) {
        _.lockCart();
        _.updateQuantity(parseInt($qty.val()), id, $qty, $item, min, max);
      });

      var idValue = itemData.id.split(":")[0];

      if (_.itemQuantities[idValue]) {
        _.itemQuantities[idValue] += parseInt(itemData.quantity);
      } else {
        _.itemQuantities[idValue] = parseInt(itemData.quantity);
      }

      if (_.itemQuantities[idValue] >= max) {
        var $variants_in = $('.js-cart-item[data-item-variant-id=' + idValue + ']');
        $.each($variants_in, function (index, item) {
          $(this).find('.js-cart-plus').prop("disabled", true);
        });
      }
    };

    Cart.prototype.addItem = function (formData) {
      var _ = this;
      var result = $.Deferred();

      $.post("/cart/add.js", formData, undefined, "json").then(function (item) {
        // Call cart to update pricing info
        $(document).trigger('cart.add', item);
        return $.post("/cart.json");
      }).then(function (data) {
        return _.updateCartInfo(data);
      }).done(function () {
        result.resolve();
      }).fail(function (error) {
        _.unlockCart();
        result.reject(error);
      });

      return result;
    };

    Cart.prototype.deleteItem = function (itemId, $item) {
      var _ = this;

      $item.addClass(_.options.classes.itemDisabled);

      $.post("/cart/change.js", { id: itemId, quantity: 0 }, undefined, "json").done(function (data) {
        $item.slideUp(function () {
          _.updateCartInfo(data);
        });
      }).fail(function () {
        $item.removeClass(_.options.classes.itemDisabled);
        _.unlockCart();
      });
    };

    /**
     * updateQuantity takes into account situations when a line item
     * splits in 2, for example on 'buy x, get y @ z discounts
     */

    Cart.prototype.updateQuantity = function (qty, itemId, $qty, $item, min, max) {
      var _ = this;

      qty = Math.max(Math.min(qty, max), min);

      $item.addClass(_.options.classes.itemDisabled);

      $.post("/cart/change.js", { id: itemId, quantity: qty }, undefined, "json").done(function (data) {

        var items = data.items.filter(function (item) {
          return item.id === itemId;
        });

        if (items.length > 0) {
          _.itemQuantities[item[0].id] = item[0].quantity;
          $(document).trigger('cart.qty_update');
          _.setItemQty($qty, items[0].quantity);
        }
        _.updateCartInfo(data);
      }).fail(function () {
        _.unlockCart();
      }).always(function () {
        $item.removeClass(_.options.classes.itemDisabled);
      });
    };

    Cart.prototype.formatMoney = function (value) {
      var _ = this;
      var price = _.options.moneyFormat.replace("{{amount}}", (value / 100).toFixed(2));
      return theme.cart_lang === 'fr' ? price.replace("$", '').replace(".", ",") + ' $' : price;
    };

    Cart.prototype.openCart = function () {
      var _ = this;
      _.$cartStyleParent.addClass(_.options.classes.cartOpened);
    };

    return Cart;
  }();

  // Initialize the cart on load
  $(function () {
    window.Cart = window.Cart || new cart(settings);
  });
})(jQuery);

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function wrapTable() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function iframeReset() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:section:reorder', this._onReorder.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function _onSectionUnload(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function _onSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function _onDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function _onReorder(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function _onBlockSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function _onBlockDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function register(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = function () {
  var moneyFormat = theme.cart_lang === 'fr' ? "{{amount}} $" : "${{amount}}";
  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, theme && theme.cart_lang && theme.cart_lang === 'fr' ? ',' : '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
}();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
}();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */

  var pswpElement = window.photoswipeDomInit();

  function Variants(options) {
    var _this = this;

    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;

    var selectedValues = this._getCurrentOptions();
    this.currentVariant = this._getVariantFromOptions(selectedValues);

    this.optionLabelUpdateSource = options.optionLabelUpdateSource;
    this.optionLabelUpdateTarget = options.optionLabelUpdateTarget;
    this.lowStockThreshold = $(options.lowStockThreshold, this.$container);
    this.lowStockThresholdValue = parseInt(this.lowStockThreshold.data(options.lowStockThreshold.replace(/\[data-|]/g, "")));
    this.$productRadios = $(options.productRadios, this.$container);
    this.sliderImageContainer = $(".product__slider-image-container", this.$container);
    this.sliderImage = $("#slider-image", this.$container);
    this.sliderThumb = $("#slider-thumbs", this.$container);
    this.$productQuantity = $(options.productQuantity, this.$container);

    this._updateRadioButtons(selectedValues, this.currentVariant);

    // Initialize slick and update slider images
    if (this.sliderImage) {

      this.images = this.buildZoomImageItems([].concat(_toConsumableArray(document.querySelectorAll('#slider-image img.pswp_image'))));

      this.sliderImage.find('.product-slideshow__zoom').on('click', function () {
        _this.zoom();
      });

      this.sliderImage.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $slide = $(slick.$slides[nextSlide]);
        if ($slide.hasClass('product-slideshow__video')) {
          var $video = $slide.find('video');
          if ($video.length) {
            $video.get(0).play();
          }
        } else {
          var $video = $(slick.$slider).find('video');
          if ($video.length) {
            $video.get(0).pause();
          }
        }
      }).slick();

      this.sliderThumb.slick();
      this._updateImages(this._getSelectedColor(selectedValues));
    }

    $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));

    $(this.optionLabelUpdateSource, this.$container).on("change", { labelTarget: this.optionLabelUpdateTarget }, function (event) {
      var updateSource = $(this);
      var updateTarget = updateSource.closest(".selector-wrapper").find(event.data.labelTarget);

      updateTarget.html(updateSource.val());
    });
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr("type");
        var currentOption = {};

        if (type === "radio" || type === "checkbox") {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      // Sort according to option index
      currentOptions = currentOptions.sort(function (a, b) {
        if (a.index < b.index) {
          return -1;
        }
        if (a.index > b.index) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions(selectedValues) {

      var variants = this.product.variants;
      var found = false;
      var multipleVariantsFound = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        // If the conditions are satisfied but we already found a variant,
        // then multiple variants satisfy the options
        if (found && satisfied) {
          multipleVariantsFound = true;
        }

        if (satisfied) {
          found = variant;
        }
      });

      if (found) {
        found.multipleVariantsFound = multipleVariantsFound;
      }

      return found || null;
    },

    /**
     * Get the selected color from the selected option values
     */
    _getSelectedColor: function _getSelectedColor(selectedValues) {
      var selectedColors = selectedValues.filter(function (element, index) {
        return element.index === "option1";
      });
      if (selectedColors.length > 0) {
        return selectedColors[0].value;
      }
    },
    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function _onSelectChange() {
      var selectedValues = this._getCurrentOptions();
      var variant = this._getVariantFromOptions(selectedValues);
      var selectedColor = this._getSelectedColor(selectedValues);

      this._updateQuantitySelector(variant);

      this.$container.trigger({
        type: "variantChange",
        variant: variant
      });

      if (variant) {
        this._updateMasterSelect(variant);
        this._updatePrice(variant);
      }

      this._updateImages(selectedColor);
      this._updateRadioButtons(selectedValues, variant);

      this._updateLowStockIndicator(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {String} variantColor - Currently selected color
     */
    _updateImages: function _updateImages(variantColor) {

      if (!variantColor) {
        return;
      }

      // Filter slick images
      var currentFilter = "[data-alt='" + theme.utils.handleize(variantColor) + "'], [data-alt='" + this.product.handle + "']";

      this.sliderImage.slick('slickUnfilter').slick("slickFilter", currentFilter);
      this.sliderThumb.slick('slickUnfilter').slick("slickFilter", currentFilter);

      // On desktop (when thumbs are visible) need to reset slick indices to
      // resolve a known bug with slick
      if (this.sliderImage.slick('getSlick').activeBreakpoint === null) {
        $('.slick-slide:not(.slick-cloned)', this.sliderImage).each(function (i) {
          $(this).attr('data-slick-index', i);
        });

        $('.slick-slide:not(.slick-cloned)', this.sliderThumb).each(function (i) {
          $(this).attr('data-slick-index', i);
        });
      }
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function _updatePrice(variant) {
      if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update radio button states
     *
     */
    _updateRadioButtons: function _updateRadioButtons(selectedValues, variant) {

      this.$productRadios.removeClass("active out-stock").find("input").prop("disabled", false);

      var variants = this.product.variants;
      var $productRadios = this.$productRadios;

      this.product.options.forEach(function (value, index) {
        var $optionRadios = $productRadios.filter("[data-option='option" + (index + 1) + "']");

        if (index > 0) {
          var selectedOptions = selectedValues.slice(0, index);

          var relevantVariants = variants.reduce(function (obj, item) {
            for (var i = 0; i < selectedOptions.length; i++) {
              if (item.options[i] !== selectedOptions[i].value) {
                return obj;
              }
            }
            obj[item.options[index]] = item;
            return obj;
          }, {});

          $optionRadios.filter(function (i, radio) {
            var optionVariant = relevantVariants[$(radio).data('value')];
            return !optionVariant || optionVariant.inventory_quantity <= 0;
          }).addClass('out-stock').find('input').prop('disabled', !theme.stockNotifications);
        }

        var selectedValue = selectedValues[index];
        if (selectedValue) {
          $optionRadios.filter("[data-value='" + selectedValue.value + "']").addClass("active");
        }
      });
    },

    /**
     * Update low stock indicator message
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateLowStockIndicator: function _updateLowStockIndicator(variant) {
      if (variant && variant.inventory_quantity <= this.lowStockThresholdValue && variant.inventory_quantity > 0 && !variant.multipleVariantsFound) {
        var $message = this.lowStockThreshold.find('.product__low-stock-message');
        var message = $message.text().replace(/[0-9]/g, variant.inventory_quantity);
        $message.text(message);
        this.lowStockThreshold.show();
      } else {
        this.lowStockThreshold.hide();
      }
    },

    /**
     * Update quantity selectors. Set max quantity and round down current quantity
     * if it is greater than the inventory of the newly selected variant
     *
     * @param {variant} variant = Currently selected variant
     */
    _updateQuantitySelector: function _updateQuantitySelector(variant) {

      if (!variant) return;

      var currentVal = parseInt(this.$productQuantity.val());
      var originalId = parseInt($(this.originalSelectorId, this.$container).first().find('[data-original-variant="' + variant.id + '"]').val());
      var cartInventory = window.Cart.itemQuantities[originalId];

      if ($.isNumeric(variant.inventory_quantity) && variant.inventory_management == 'shopify') {
        var maxQty = 1;

        if ($.isNumeric(cartInventory)) {
          maxQty = Math.max(1, variant.inventory_quantity - cartInventory);

          variant.allInCart = variant.inventory_quantity - cartInventory < 1;
        } else {
          maxQty = Math.max(1, variant.inventory_quantity);
          variant.allInCart = false;
        }

        this.$productQuantity.attr("max", maxQty);

        if (!isNaN(currentVal)) {
          this.$productQuantity.val(Math.min(currentVal, maxQty));
        }
      } else {
        this.$productQuantity.removeAttr("max");
        variant.allInCart = false;
      }
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function _updateMasterSelect(variant) {
      var $option = $(this.originalSelectorId, this.$container).first().find('[data-original-variant="' + variant.id + '"]');

      if ($option.length) {
        $option.prop('selected', true).trigger('change').trigger('variantSet');
      }
    },

    buildZoomImageItems: function buildZoomImageItems(images) {
      return images.map(function (image) {
        return {
          // remove (?:_\d*x\d*) from the regex if the src is not resized by shopify
          // 1400x2100 picked as a maximum size as defined by photoswipe for performance reasons
          src: image.src.replace(/(?:_\d*x\d*)(?=\.[^.?]*\?)/, '_1400x2100'),
          w: 1400,
          h: 2100
        };
      });
    },

    zoom: function zoom() {
      var slideIndex = +(document.querySelector('#slider-image .slick-active') ? document.querySelector('#slider-image .slick-active').dataset.index : 0);
      var gallery = new PhotoSwipe(pswpElement, window.photoSwipeUI, this.images, {
        closeOnScroll: false,
        fullscreenEl: false,
        shareEl: false,
        index: slideIndex
      });

      gallery.init();
    }
  });

  return Variants;
}();

/*================ Modules ================*/

var FiltersEngine = function () {
  function FiltersEngine(resource) {
    _classCallCheck(this, FiltersEngine);

    if (!(resource instanceof FiltersResource)) {
      throw '[FiltersEngine]: Parameter "resource" must be an instance of FiltersResource';
    }

    this.resource = resource;
    this.state = this.loadState();

    this.currentFilters = [];
    this.currentSorting = [];
    this.lastResultSet = [];
    this.currentCount = 1;
    this.currentPage = Number(this.state.page) || 1;
    this.pageSize = 12;
    this.pageCount = 1;
    this.collection = '';
    this.search = '';
    this.query = '';
  }

  _createClass(FiltersEngine, [{
    key: 'getResults',
    value: function getResults() {
      var _this2 = this;

      return this.resource.query(this.params).then(function (_ref) {
        var results = _ref.results,
            count = _ref.count,
            options = _ref.options;

        _this2.results = results || [];
        _this2.count = count || 0;
        _this2.options = options || [];
      });
    }
  }, {
    key: 'loadState',
    value: function loadState() {
      return theme.utils.getURLParams();
    }
  }, {
    key: 'saveState',
    value: function saveState() {
      var state = {};
      this.filters.forEach(function (filter) {
        return state[filter.key] = filter.getActiveOptions();
      });
      this.sorting.forEach(function (sort) {
        return state[sort.key] = sort.getActiveOptions();
      });
      state.page = this.page;
      theme.utils.setURLParams(state, { push_state: true });
    }
  }, {
    key: 'results',
    get: function get() {
      return this.lastResultSet;
    },
    set: function set(results) {
      this.lastResultSet = results;
    }
  }, {
    key: 'count',
    get: function get() {
      return this.currentCount;
    },
    set: function set(count) {
      this.currentCount = count;
      this.pageCount = Math.ceil(this.currentCount / this.pageSize);
    }
  }, {
    key: 'page',
    get: function get() {
      return this.currentPage;
    },
    set: function set(page) {
      this.currentPage = Math.min(Math.max(page, 1), this.pageCount);
    }
  }, {
    key: 'filters',
    get: function get() {
      return this.currentFilters;
    },
    set: function set(filters) {
      var _this3 = this;

      filters.forEach(function (filter) {
        return filter.state = _this3.state[filter.key] ? _this3.state[filter.key].split(',') : [];
      });
      this.currentFilters = filters;
    }
  }, {
    key: 'sorting',
    get: function get() {
      return this.currentSorting;
    },
    set: function set(sorting) {
      var _this4 = this;

      sorting.forEach(function (sort) {
        return sort.state = _this4.state[sort.key] ? _this4.state[sort.key].split(',') : [];
      });
      this.currentSorting = sorting;
    }
  }, {
    key: 'params',
    get: function get() {
      return {
        collection: this.collection,
        search: this.search,
        query: this.query,
        filters: this.filters,
        sorting: this.sorting,
        page: this.page,
        pageSize: this.pageSize
      };
    }
  }]);

  return FiltersEngine;
}();

var FiltersResource = function () {
  function FiltersResource() {
    _classCallCheck(this, FiltersResource);
  }

  _createClass(FiltersResource, [{
    key: 'query',
    value: function query(params) {
      return Promise.all([{
        results: [],
        count: 0,
        options: [],
        params: params
      }]);
    }
  }]);

  return FiltersResource;
}();

var FiltersUI = function () {
  function FiltersUI(engine) {
    _classCallCheck(this, FiltersUI);

    if (!(engine instanceof FiltersEngine)) {
      throw '[FiltersEngine]: Parameter "engine" must be an instance of FiltersEngine';
    }
    this.engine = engine;
  }

  _createClass(FiltersUI, [{
    key: 'init',
    value: function init() {
      this.engine.filters = this.initFilters();
      this.engine.sorting = this.initSorting();
    }
  }, {
    key: 'initFilters',
    value: function initFilters() {
      return [];
    }
  }, {
    key: 'initSorting',
    value: function initSorting() {
      return [];
    }
  }, {
    key: 'renderFilters',
    value: function renderFilters(filters) {
      return filters;
    }
  }, {
    key: 'renderActiveFilters',
    value: function renderActiveFilters(filters) {
      return filters;
    }
  }, {
    key: 'renderPages',
    value: function renderPages(pages) {
      return pages;
    }
  }, {
    key: 'renderResults',
    value: function renderResults(results) {
      return results;
    }
  }]);

  return FiltersUI;
}();

var SimpleFilter = function () {
  function SimpleFilter(element, key, values) {
    var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    _classCallCheck(this, SimpleFilter);

    this.element = element;
    this.key = key;
    this.values = values || [];
    this.values = this.values.map(function (value) {
      return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value : { name: value, value: value };
    });
    this.state = state;
    this.renderer = new FilterRenderer(this);
  }

  _createClass(SimpleFilter, [{
    key: 'getOptionConfig',
    value: function getOptionConfig() {
      return this.key;
    }
  }, {
    key: 'renderOptions',
    value: function renderOptions(options) {
      var _this5 = this;

      Object.keys(options[this.key]).forEach(function (option) {
        var existing = _this5.values.find(function (value) {
          return value.value.indexOf(option) >= 0;
        });
        if (existing) {
          existing.count = options[_this5.key][option];
        } else {
          _this5.values.push({ name: option, value: option, count: options[_this5.key][option] });
        }
      });
      this.values = this.values.filter(function (value) {
        return value.count && value.count > 0;
      });
      this.renderer.render(this.values);
    }
  }, {
    key: 'renderActiveOptions',
    value: function renderActiveOptions() {
      var _this6 = this;

      return this.getActiveOptions().map(function (value) {
        return _this6.renderer.renderActive(value);
      });
    }
  }, {
    key: 'getActiveOptions',
    value: function getActiveOptions() {
      var options = [];
      this.element.querySelectorAll('input:checked').forEach(function (input) {
        return options.push(input.value);
      });
      return options.filter(function (option, index, array) {
        return array.indexOf(option) === index;
      });
    }
  }, {
    key: 'apply',
    value: function apply(query) {
      var _this7 = this;

      var values = this.getActiveOptions().reduce(function (options, option) {
        var value = _this7.values.find(function (value) {
          return value.name === option;
        });
        return options.concat(value ? value.value : option);
      }, []);
      if (values.length) {
        query[this.key]('in', values);
      }
      return query;
    }
  }]);

  return SimpleFilter;
}();

var Renderer = function () {
  function Renderer() {
    _classCallCheck(this, Renderer);

    this.data = null;
  }

  _createClass(Renderer, [{
    key: 'render',
    value: function render(data) {
      this.data = data;
      return this.data;
    }
  }]);

  return Renderer;
}();

var FilterRenderer = function (_Renderer) {
  _inherits(FilterRenderer, _Renderer);

  function FilterRenderer(filter) {
    _classCallCheck(this, FilterRenderer);

    var _this8 = _possibleConstructorReturn(this, (FilterRenderer.__proto__ || Object.getPrototypeOf(FilterRenderer)).call(this));

    _this8.container = filter.element;
    _this8.filter = filter;
    return _this8;
  }

  _createClass(FilterRenderer, [{
    key: 'render',
    value: function render(options) {
      var _this9 = this;

      options = _get(FilterRenderer.prototype.__proto__ || Object.getPrototypeOf(FilterRenderer.prototype), 'render', this).call(this, options).reduce(function (html, option) {
        return html + ('\n      <li class="filter-option">\n        <input type="checkbox" id="filter-' + _this9.filter.key + '-' + option.name + '" name="' + _this9.filter.key + '" value="' + option.name + '"\n          ' + (_this9.filter.state.indexOf(option.name) > -1 ? 'checked' : '') + '>\n        <label for="filter-' + _this9.filter.key + '-' + option.name + '">' + _this9.renderLabel(option.name) + '</label>\n      </li>\n      ');
      }, '');
      this.container.querySelector('.filter-options').innerHTML = options;
    }
  }, {
    key: 'renderActive',
    value: function renderActive(value) {
      return '<label class="filter-breadcrumb" for="filter-' + this.filter.key + '-' + value + '">' + this.renderLabel(value) + '</label>';
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel(label) {
      return label;
    }
  }]);

  return FilterRenderer;
}(Renderer);

var SpotResource = function (_FiltersResource) {
  _inherits(SpotResource, _FiltersResource);

  function SpotResource(api) {
    var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SpotResource);

    if (!(api instanceof SpotAPI)) {
      throw 'SpotResource requires an instance of SpotAPI';
    }

    var _this10 = _possibleConstructorReturn(this, (SpotResource.__proto__ || Object.getPrototypeOf(SpotResource)).call(this));

    _this10.api = api;
    _this10.setDefaultQuery(defaultParams);

    _this10.sortMap = {
      'popular': 'manual',
      'relevant': 'search',
      'title-ascending': { 'asc': 'title' },
      'title-descending': { 'desc': 'title' },
      'price-ascending': { 'asc': 'price' },
      'price-descending': { 'desc': 'price' },
      'created-ascending': { 'asc': 'price' },
      'created-descending': { 'desc': 'price' }
    };
    return _this10;
  }

  _createClass(SpotResource, [{
    key: 'setDefaultQuery',
    value: function setDefaultQuery(params) {
      this.api.defaultQuery(Object.keys(params).reduce(function (query, method) {
        return query[method].apply(query, params[method]);
      }, this.api.s()));
    }
  }, {
    key: 'query',
    value: function query(params) {
      var _this11 = this;

      var query = this.api.s().paginate(params.pageSize).page(params.page);
      query.options(params.filters.map(function (filter) {
        return filter.getOptionConfig();
      }), true);

      if (params.collection) {
        query.collection(params.collection);
      }

      if (params.search) {
        query.search(params.search);
        query.tag('language_' + window.theme.language);
      }

      params.filters.filter(function (filter) {
        return filter.getActiveOptions().length;
      }).forEach(function (filter) {
        return filter.apply(query);
      });
      params.sorting.map(function (sort) {
        return sort.getActiveOptions();
      }).filter(function (options) {
        return options.length;
      }).map(function (sort) {
        return _this11.sortMap[sort] || sort[0];
      }).forEach(function (sort) {
        return query.sort(sort);
      });

      var promise = $.Deferred();
      query.e(function (products, count, options) {
        promise.resolve({
          results: products || [],
          count: count || 0,
          options: options.options || []
        });
      });
      return promise.promise();
    }
  }]);

  return SpotResource;
}(FiltersResource);

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = function () {
  var selectors = {
    addToCart: "[data-add-to-cart]",
    addToCartText: "[data-add-to-cart-text]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]",
    optionLabelUpdateSource: "[data-single-option-update-label]",
    optionLabelUpdateTarget: "[data-single-option-label]",
    productLowStock: "[data-stock-threshold]",
    productRadios: ".product__radio",
    productDescription: "#product__description",
    productQuantity: "#Quantity",
    productQuantityPlus: "[data-product-quantity-plus]",
    productQuantityMinus: "[data-product-quantity-minus]",
    productForm: "[data-product-form]",
    productSelector: "[data-product-selector]"
  };

  var pswpElement = window.photoswipeDomInit();

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    var _this12 = this;

    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var descriptionContainer = $(selectors.productDescription, this.$container);

    if (descriptionContainer.length > 0) {
      descriptionContainer.easyResponsiveTabs({
        tabidentify: 'resp-element',
        closed: true,
        inactive_bg: '#fff',
        active_border_color: '#000'
      });
    }

    if (this.productSingleObject.variants.length == 0) {
      this.images = this.buildZoomImageItems([].concat(_toConsumableArray(document.querySelectorAll('#slider-image img.pswp_image'))));

      this.$container.find('.product-slideshow__zoom').on('click', function () {
        _this12.zoom();
      });

      $('#slider-image').slick();
      $('#slider-thumbs').slick();
      return false;
    }

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      optionLabelUpdateSource: selectors.optionLabelUpdateSource,
      optionLabelUpdateTarget: selectors.optionLabelUpdateTarget,
      lowStockThreshold: selectors.productLowStock,
      product: this.productSingleObject,
      productRadios: selectors.productRadios,
      productQuantity: selectors.productQuantity
    };

    this.settings = {};
    this.namespace = ".product";
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.variants = new slate.Variants(options);

    this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this));

    if (theme.stockNotifications) {
      $(selectors.productSelector).addClass('atc--stock-notifications');
    }

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featured_image.attr("src"));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this));
    }

    var $productQuantity = $(selectors.productQuantity, this.$container);

    $(selectors.productQuantityPlus, this.$container).on('click', { $quantity: $productQuantity }, function (event) {
      var $quantity = event.data.$quantity;
      var max = parseInt($quantity.attr('max'));
      var currentVal = parseInt($quantity.val());

      if (isNaN(currentVal)) {
        $quantity.val(1);
      } else {
        if (!isNaN(max)) {
          $quantity.val(Math.min(currentVal + 1, max));
        } else {
          $quantity.val(currentVal + 1);
        }
      }
    });

    $(selectors.productQuantityMinus, this.$container).on('click', { $quantity: $productQuantity }, function (event) {
      var $quantity = event.data.$quantity;
      var min = parseInt($quantity.attr('min'));
      var currentVal = parseInt($quantity.val());

      if (isNaN(currentVal)) {
        console.log("val is nan");
        if (!isNaN(min)) {
          $quantity.val(min);
        } else {
          $quantity.val(1);
        }
      } else {
        if (!isNaN(min)) {
          $quantity.val(Math.max(currentVal - 1, min));
        } else {
          $quantity.val(currentVal - 1);
        }
      }
    });

    $(document).on('cart.qty_update', { product: this }, function (event) {
      var variants = event.data.product.variants;
      variants._updateQuantitySelector(variants.currentVariant);
      event.data.product.updateAddToCartState({ variant: variants.currentVariant });
    });

    var $productForm = $(selectors.productForm, this.$container);
    $productForm.submit(function (e) {
      e.preventDefault();

      var $form = $(this);

      var atc = $(selectors.addToCartText, this.$container);
      atc.html(theme.strings.adding);

      window.Cart.addItem($(this).serialize()).done(function () {
        window.Cart.openCart();

        atc.html(theme.strings.added);
      }).fail(function () {
        atc.html(theme.strings.addingFail);
        console.log("failed to add");
      }).always(function () {
        setTimeout(function () {
          // Trigger a quantity update to update atc button text
          $(document).trigger('cart.qty_update');
        }, 4000);
      });
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function updateAddToCartState(evt) {
      var variant = evt.variant;

      $(selectors.addToCart, this.$container).removeClass('atc--out-of-stock');
      $(selectors.addToCartText, this.$container).removeClass('text--out-of-stock');

      if (!variant) {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        return;
      }

      if (variant.multipleVariantsFound) {
        return;
      } else if (variant.allInCart) {
        $(selectors.addToCart, this.$container).prop("disabled", true);
        $(selectors.addToCartText, this.$container).html(theme.strings.incart);
      } else if (variant.available) {
        $(selectors.addToCart, this.$container).prop("disabled", false);

        if ($(selectors.addToCart, this.$container).hasClass('product__atc--pre-order')) {
          $(selectors.addToCartText, this.$container).html(theme.strings.preOrder);

          return;
        }

        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).addClass('atc--out-of-stock').prop('disabled', !theme.stockNotifications);
        $(selectors.addToCartText, this.$container).addClass('text--out-of-stock').html(theme.stockNotifications ? theme.strings.outOfStock : theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function updateProductPrices(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var $productPrice = $(selectors.productPrice, this.$container);

      $productPrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass("hide");
        $productPrice.addClass("product__discount");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
        $productPrice.removeClass("product__discount");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function updateProductImage(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featured_image.attr("src", sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function onUnload() {
      this.$container.off(this.namespace);
    },

    buildZoomImageItems: function buildZoomImageItems(images) {
      return images.map(function (image) {
        return {
          // remove (?:_\d*x\d*) from the regex if the src is not resized by shopify
          // 1400x2100 picked as a maximum size as defined by photoswipe for performance reasons
          src: image.src.replace(/(?:_\d*x\d*)(?=\.[^.?]*\?)/, '_1400x2100'),
          w: 1400,
          h: 2100
        };
      });
    },

    zoom: function zoom() {
      var slideIndex = +(document.querySelector('#slider-image .slick-active') ? document.querySelector('#slider-image .slick-active').dataset.index : 0);
      var gallery = new PhotoSwipe(pswpElement, window.photoSwipeUI, this.images, {
        closeOnScroll: false,
        fullscreenEl: false,
        shareEl: false,
        index: slideIndex
      });

      gallery.init();
    }
  });

  return Product;
}();

theme.featuredCollection = function () {
  var x;
  var $featured_collection = $('[data-featured-collection]');
  var $curated_collection_slick = $('.curated-collection-slick');
  var $super_collection_container = $('.super-collection__container');
  var $sc_slick_block = $('.sc-slick-block');

  $featured_collection.on('init reInit', function (event, slick) {
    $(this).find('[data-product-tile-load]').removeClass('is-loading');
  });

  var initialize = function initialize() {
    $curated_collection_slick.slick({
      autoplay: false,
      dots: false,
      swipe: false,
      touchMove: false,
      slidesToShow: 5,
      lazyLoad: 'ondemand',
      focusOnSelect: false,
      arrows: false,
      responsive: [{
        breakpoint: 990,
        settings: {
          draggable: false,
          swipeToSlide: false,
          swipe: false,
          slidesToShow: 3,
          arrows: false,
          autoplay: false,
          infinite: true,
          dots: true
        }
      }, {
        breakpoint: 768,
        settings: {
          draggable: false,
          swipeToSlide: false,
          swipe: false,
          slidesToShow: 2,
          arrows: false,
          autoplay: false,
          infinite: true,
          dots: true
        }
      }]
    });

    $super_collection_container.slick({
      autoplay: false,
      dots: true,
      swipe: true,
      touchMove: false,
      slidesToShow: 1,
      lazyLoad: 'ondemand',
      focusOnSelect: false,
      arrows: false
    });

    $sc_slick_block.slick({
      centerMode: true,
      autoplay: false,
      dots: true,
      swipe: true,
      touchMove: true,
      slidesToShow: 1,
      lazyLoad: 'ondemand',
      focusOnSelect: true,
      centerPadding: '12.5%'
    });

    $featured_collection.slick({ infinite: false, centerMode: false });
  };

  $(function () {
    initialize();

    $(document).on('shopify:section:load', function () {
      initialize();
    });
  });
}();
slate.Collection = function () {
  var old_hovered_img = '';
  var data_img = '';
  var new_hovered_img = '';
  var clicked = false;

  var $staticParents = $('.featured-collection-container, .collection.wrapper--section-content.grid, .nosto_element, .search__content-output');

  // ------------------------------
  // PRODUCT TILE
  // ------------------------------

  // Update tile image on click of a color swatch
  $staticParents.on('click', '.featured-collection__info .product__option-selector .radio-color', function () {
    clicked = true;
    data_img = $(this).closest('.featured-collection__info').find('.featured_collection__image');

    new_hovered_img = $(this).data('variantImage');
    if (!new_hovered_img) return false;
    data_img.attr('src', new_hovered_img);
  });

  // Update tile image on mouse enter of color swatch
  $staticParents.on('mouseenter', '.featured-collection__info .product__option-selector .radio-color', function () {
    data_img = $(this).closest('.featured-collection__info').find('.featured_collection__image');
    new_hovered_img = $(this).data('variant-image');
    old_hovered_img = data_img.attr('src');
    if (!new_hovered_img) return false;
    data_img.attr('src', new_hovered_img);
  });

  // Update tile image on mouse leave of color swatch
  $staticParents.on('mouseleave', '.featured-collection__info .product__option-selector .radio-color', function () {
    if (clicked) {
      clicked = false;
      return;
    }
    if (!old_hovered_img) return false;
    data_img.attr('src', old_hovered_img);
  });

  // ------------------------------
  // FILTERS
  // ------------------------------

  // Filter panels
  function openPanel($section) {
    closePanel($('.filter-section').not($section));
    $section.addClass('active');
    $section.find('.filter-expander').addClass('open');
    $section.find('.filter-options').slideDown(300);
  }
  function closePanel($section) {
    $section.removeClass('active');
    $section.find('.filter-expander').removeClass('open');
    $section.find('.filter-options').slideUp(300);
  }

  // Filter expand
  $('.js-filter-expand').click(function () {
    var $section = $(this).closest('.filter-section');

    if ($section.hasClass('active')) {
      closePanel($section);
    } else {
      openPanel($section);
    }
  });

  // Filters click-away
  $(document).click(function (event) {
    if (!$(event.target).closest('.filter-section').length) {
      closePanel($('.filter-section'));
    }
  });

  // Filters mobile collapse
  // Filters mobile collapse
  $('.js-filters-toggle').click(function () {
    $(this).closest('[data-filter-container]').toggleClass('active').find('.filters').slideToggle();
  });

  $('#collection-list').on('change', '.swatch-radio', function () {
    var $optionKey = $(this).data('index');
    var $optionVal = $(this).val();
    $(this).closest('form').find($('[data-option-index=' + $optionKey + ']')).val($optionVal);
  });
}();

theme.Header = function () {
  $(function () {
    $('.show-center').click(function () {
      $('.meganav').removeClass('meganav-show-left meganav-show-right').addClass('meganav-show-center');
      $('body').addClass('no-scroll');
    });
    $('.show-left').click(function () {
      $('.meganav').removeClass('meganav-show-center meganav-show-right').toggleClass('meganav-show-left');
      $('body').addClass('no-scroll');
    });
    $('.show-right').click(function () {
      $('.meganav').removeClass('meganav-show-left meganav-show-center').toggleClass('meganav-show-right');
      $('body').addClass('no-scroll');
    });
    $('.show-none, .show-center, .show-left, .show-right').click(function (e) {
      e.stopPropagation();
    });
    $(document).on('click', function (e) {
      var $chain = $(e.target).parents().addBack();
      if (!$chain.is('.meganav-left, .meganav-right, .meganav-center')) {
        $('.meganav').removeClass('meganav-show-left meganav-show-center meganav-show-right');
        $('#nav-toggle').removeClass('active');
        $('body').removeClass('no-scroll');
      }
    });
  });

  $(function () {
    $(".mm-sublist").mouseover(function () {
      var listName = $(this).data("menuitem");
      $(".mm-sublist").removeClass('sub-menu-active');

      //check if it is part of the shop menu
      $(".mm-sublist.shop").addClass('sub-menu-inactive');

      if ($(this).hasClass('shop')) {
        $(this).removeClass('sub-menu-inactive');
      }

      $(this).addClass('sub-menu-active');
      $(".inner-menu-list").removeClass("active-menu");
      $(".inner-menu-container").find("ul ." + listName).toggleClass("active-menu");
    });
  });

  $(function () {
    //Header Height
    var headerHeight = $("#navigation-header").outerHeight();
    $(window).resize(function () {
      headerHeight = $("#navigation-header").outerHeight();
      var windowSize = $(window).width();

      if (windowSize > 1024) {
        $('body').removeClass('no-scroll');
        $('.meganav').removeClass('meganav-show-left');
        $('#nav-toggle').removeClass('active');
      }
    });

    $(window).scroll(function () {
      var windowSize = $(window).width();
      if (windowSize > 1024) {
        //Elements
        var $header = $("#navigation-header");
        var $pageContainer = $header.siblings(".container");
        var $supportList = $header.find("#support-list-container");
        var $cartList = $("#cart-item-container").find(".cart-li");
        var $searchContainer = $header.find("#search-container");
        var $logoContainer = $header.find("#logo-container");
        //Window Variables
        var windowTop = $(window).scrollTop();

        //if windowTop > headerHeight make header fixed and shrink to smaller header
        if (windowTop > headerHeight) {
          $pageContainer.css({ 'margin-top': headerHeight });
          //Transition downwards if header isn't fixed
          if (!$header.hasClass('scroll-fixed')) {
            $header.addClass('scroll-transition').delay(100).queue(function () {
              $header.addClass('scroll-fixed').dequeue();
              $header.removeClass('scroll-transition').dequeue();
            });
          }

          //if > 1200
          if (windowSize > 1200) {
            $supportList.addClass("scroll-support");
            $cartList.addClass("scroll-cart");
            $searchContainer.addClass("scroll-search");
            $logoContainer.addClass('scroll-logo');
          }
        } else {
          //if header was fixed
          if ($header.hasClass('scroll-fixed')) {
            $header.removeClass('scroll-transition');
            $header.removeClass('scroll-fixed');
            $pageContainer.css({ 'margin-top': '0' });

            //1200px
            $supportList.removeClass("scroll-support");
            $cartList.removeClass("scroll-cart");
            $searchContainer.removeClass("scroll-search");
            $logoContainer.removeClass('scroll-logo');
          }
        }
      }
    });
  });

  $(function () {
    $('#nav-toggle, .container.meganav-page-content').on("click", function () {
      if ($('#nav-toggle').hasClass('active')) {
        $('#nav-toggle').removeClass('active');
      } else {
        $('#nav-toggle').addClass('active');
      }
    });

    $('.mobile-nav__parent .mobile-nav__link').on("click", function () {
      var $accordion = $(this).parent().find('.mobile-nav__dropdown');
      $accordion.toggleClass('active__accordion').slideToggle();

      if ($accordion.hasClass('active__accordion')) {
        $(this).find('.plus .fa').first().addClass('active');
      } else {
        $(this).find('.plus .fa').first().removeClass('active');
      }
    });

    $('.mobile-nav__child .mobile-nav__link-child').on("click", function () {
      var $this = $(this);
      var $accordion = $this.parent().find('.panel');

      $accordion.toggleClass('active__accordion').slideToggle();

      if ($accordion.hasClass('active__accordion')) {
        $this.find('.plus .fa').first().addClass('active');
      } else {
        $this.find('.plus .fa').first().removeClass('active');
      }
    });
  });

  $(function () {
    function setBrand(selected_brand, brand_url) {
      // Stores the brand name into cart.attributtes so that
      // that it can be used as a caching system to determine
      // what brand a product belongs.

      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { 'attributes[brand]': selected_brand },
        dataType: 'json',
        success: function success(data) {
          if (brand_url) {
            window.location.href = brand_url;
          }
        }
      });
    }

    $('.js-brand-selector').click(function () {
      var brand_tab = $(this).find('.js-brand-tab');
      var brand_url = brand_tab.data('brand-url');
      var selected_brand = brand_tab.data('selected-brand');

      setBrand(selected_brand, brand_url);
    });

    if (theme.cart_json && theme.cart_json.attributes && theme.brand && theme.cart_json.attributes.brand !== theme.brand) {
      setBrand(theme.brand);
    }
  });
}();
theme.footer = function () {
  $(function () {
    $('.site-footer__menu .menu__col').click(function (e) {
      $(this).find('.col-menu__list-menu').toggleClass('active__accordion');
      // $(this).parent().siblings('.mobile-menu__column, .footer-nav__column').slideToggle();
      if ($(this).find('.col-menu__list-menu').hasClass('active__accordion')) {
        $(this).find('.col-menu__header .triangle').css({ "transition": "0.4s", "transform": "rotate(180deg)" });
      } else {
        $(this).find('.col-menu__header .triangle').css({ "transition": "0.4s", "transform": "rotate(360deg)" });
      }
    });
  });
}();
window.store_map_loaded = $.Deferred();

$(function () {
  /**
   * The store locator object takes care of filtering,
   * rendering the map, handling filters, geo location,
   * geo coding, rendering store results, and pagination
   */
  var Store_locator = new function () {
    function Store_locator() {
      var store_locator = this;

      this.key = "AIzaSyD8b7s2bvul5zDXKxGr_hMZ2FcSGuf6ah0";
      this.$container = $(".js-store-locator");
      this.$resultsCountContainer = $(".js-results-count-container");
      this.$resultsCount = $(".js-results-count", this.$resultsCountContainer);
      this.$storeListContainer = $(".js-store-list", this.$container);
      this.$radiusCopy = $(".js-radius-dropdown-copy", this.$container);
      this.$filterRadius = $(".js-filter-radius", this.$container);
      this.$geolocateButton = $(".js-geolocate", this.$container);
      this.$addressLookup = $(".js-search-input", this.$container);
      this.$addressSubmit = $(".js-search-submit", this.$container);
      this.$mapToggleButton = $(".js-map-toggle", this.$container);
      this.$mapContainer = $("#map_container", this.$container);
      this.$locationNearby = $('.js-location-near', this.$container);

      this.dropdowns = new Dropdowns(this.$container);
      this.pagination = new Pagination($('.js-pagination-container', this.$container), this);

      this.filtersManager = new FilterManager($('.js-filters-container', this.$container), $('.js-selected-filters', this.$container), this);

      this.previousWidth = window.outerWidth;
      this.fitBoundsPadding = 40;
      this.countPerPage = 6;
      this.markers = [];
      this.labels = [];
      this.storepicker = this.$container.hasClass("js-store__picker");
      this.defaultNearbyLocation = this.$locationNearby.data('default');

      this.$geolocateButton.on('click', function () {
        store_locator.geolocate();
      });

      this.$addressSubmit.submit(function () {
        store_locator.geocode();
        return false;
      });

      this.$mapToggleButton.on('click', function () {
        store_locator.$mapToggleButton.toggleClass('active');
        store_locator.toggleMap();
      });

      this.$filterRadius.on('change', function () {
        store_locator.$radiusCopy.html($(this).data('title'));
        store_locator.loadStores();
      });

      $(window).resize(function () {
        if (window.outerWidth >= 1024 && store_locator.previousWidth < 1024 && !store_locator.storepicker) {
          store_locator.$mapToggleButton.addClass('active');
          store_locator.toggleMap();
        } else if (window.outerWidth < 1024 && store_locator.previousWidth >= 1024 || store_locator.storepicker) {
          store_locator.$mapToggleButton.removeClass('active');
          store_locator.toggleMap();
        } else if (store_locator.storeBounds) {
          window.theme.map.fitBounds(store_locator.storeBounds, store_locator.fitBoundsPadding);
        }

        store_locator.previousWidth = window.outerWidth;
      });

      if (store_locator.storepicker) {
        var checkoutDestination = store_locator.$container.data('checkout-destination');

        store_locator.$storeListContainer.on('click', '.js-pick-store', function () {
          var id = this.getAttribute('data-store-id');
          var this_store = store_locator.stores[id];
          checkoutDestination += this_store.checkout_auto_fill;
          var store_brand = this_store.brand;
          var open_hours = this_store.open_hours;
          var store_address = this_store.address;
          var store_tel = this_store.phone;
          var store_full_name = store_address.name + " " + this_store.brand + " #" + this_store.store_code;
          var store_code = this_store.store_code;

          $.post('/cart/update.js', {
            attributes: {
              checkout_type: "store",
              open_hours: JSON.stringify(open_hours),
              store_address: JSON.stringify(store_address),
              store_tel: store_tel,
              store_brand: store_brand,
              store_name: store_address.name,
              store_code: store_code,
              store_full_name: store_full_name,
              store_formatted_hours: store_locator.processHours(open_hours).join('')
            }
          }, function () {
            window.location.href = checkoutDestination;
          }, "json");
        });
      }
      if (window.outerWidth >= 1024 && !store_locator.storepicker) {
        store_locator.$mapToggleButton.addClass('active');
      }
    }

    /**
     * The Dropdowns object keeps track of all the dropdowns and ensuring that
     * atmost only one is open at a time.
     * @param {Object} $container - Container holding dropdown elements
     */
    function Dropdowns($container) {
      var dropdowns = this;
      dropdowns.$container = $container;
      dropdowns.$active = undefined;

      dropdowns.$dropdownsElements = $(".js-dropdown-toggle", this.$container);

      dropdowns.Toggle = function Toggle($trigger) {
        if (dropdowns.$active === $trigger) {
          dropdowns.$active = undefined;
          $trigger.deactivate();
        } else if (dropdowns.$active) {
          dropdowns.$active.deactivate(function () {
            $trigger.activate();
            dropdowns.$active = $trigger;
          });
        } else {
          $trigger.activate();
          dropdowns.$active = $trigger;
        }
      };

      this.dropdownObjects = $.map(dropdowns.$dropdownsElements, function (element) {
        return new Dropdown(element, dropdowns.$container, dropdowns.Toggle);
      });
    }

    /**
     * The Dropdown object represents a single dropdown that can slide down and up
     *
     * @param {object} button - The dropdown's toggle button
     * @param {object} $container - Container of dropdown elements
     * @param {function} toggle - Funtion to call when the dropdown request a toggle
     */
    function Dropdown(button, $container, toggle) {
      var dropdown = this;
      dropdown.$button = $(button);
      dropdown.toggle = toggle;
      dropdown.$dropdown = $(dropdown.$button.data('for'), $container);

      dropdown.$button.on('click', function () {
        dropdown.toggle(dropdown);
      });

      dropdown.deactivate = function (completed) {
        dropdown.$dropdown.slideUp(completed);
        dropdown.$button.removeClass('active');
      };

      dropdown.activate = function () {
        dropdown.$dropdown.slideDown();
        dropdown.$button.addClass('active');
      };
    }

    /**
     * The Pagination object creates pagination dropdown elements,
     * handles pagination GUI item click events, and keeps track of page
     * changes notifying the store locator of which page to load
     *
     * @param {object} $container - Pagination elements container
     * @param {Store_locator} store_locator - The main store locator
     */
    function Pagination($container, store_locator) {
      var pagination = this;
      this.store_locator = store_locator;
      this.pages = 1;
      this.page = 1;

      this.$dropdown = $('.js-pagination-dropdown', $container);
      this.$previous = $('.js-pagination-prev', $container);
      this.$next = $('.js-pagination-next', $container);
      this.$lastpage = $('.js-pagination-last', $container);

      this.$next.on('click', function () {
        if (pagination.page < pagination.pages) {
          pagination.updatePagination(pagination.page + 1);
        }
      });

      this.$previous.on('click', function () {
        if (pagination.page > 1) {
          pagination.updatePagination(pagination.page - 1);
        }
      });

      this.$dropdown.on('change', function () {
        pagination.updatePagination(parseInt(pagination.$dropdown.val()));
      });

      // Create the pagination dropdown elements
      this.setupPagination = function (count) {
        pagination.pages = Math.ceil(count / store_locator.countPerPage);

        pagination.$lastpage.html(pagination.pages);

        var dropdownOptions = [];
        for (var i = 1; i <= pagination.pages; i++) {
          var index = i.toString();
          dropdownOptions.push('<option value="');
          dropdownOptions.push(index);
          dropdownOptions.push('">');
          dropdownOptions.push(index);
          dropdownOptions.push('</option>');
        }
        pagination.$dropdown.html(dropdownOptions.join(''));
      };

      // Update page information and load the requested page
      this.updatePagination = function (page) {
        pagination.$previous.css('visibility', page === 1 ? 'hidden' : 'visible');
        pagination.$next.css('visibility', page === pagination.pages ? 'hidden' : 'visible');
        pagination.$dropdown.val(page);
        pagination.page = page;
        pagination.store_locator.renderPage(page);
      };
    }

    /**
     * The Filter Manager adds and removes filters, keeps track of active filters
     * and enables the clearing of all filters;
     *
     * @param {Object} $filtersContainer - Container holding the filters
     * @param {Object} $selectedFiltersContainer - Container holding the bar were selected filters are displayed
     */
    function FilterManager($filtersContainer, $selectedFiltersContainer, store_locator) {
      var manager = this;

      manager.$filterTags = $(".js-filter-tag", $filtersContainer);
      manager.$selectedFilterLists = $(".js-filters-list", $selectedFiltersContainer);
      manager.$clearAll = $('.js-clear-all-filters', $selectedFiltersContainer);
      manager.selectedFilters = new Set();

      // Create the filters
      manager.filters = $.map(manager.$filterTags, function (element) {
        return new Filter($(element), manager);
      });

      // Add a filer
      manager.attach = function (filter) {
        manager.$selectedFilterLists.append(filter.$element);
        manager.selectedFilters.add(filter);
        manager.update();
      };

      // Remove a filter
      manager.detach = function (filter) {
        filter.deactive();
        manager.selectedFilters.delete(filter);
        manager.update();
      };

      manager.$clearAll.on('click', function (e) {
        e.preventDefault();

        manager.selectedFilters.forEach(function (filter) {
          filter.deactive();
        });
        manager.selectedFilters.clear();
        manager.update();
      });

      // Show or hide the filters bar
      manager.update = function () {
        if (manager.selectedFilters.size > 0) {
          $selectedFiltersContainer.show();
        } else {
          $selectedFiltersContainer.hide();
        }

        store_locator.loadStores();
      };
    }

    /**
     * A Filter object keeps track of a filter's checkbox and
     * badge that appears in the selected filters bar
     *
     * @param {object} $filter - The filter's input element
     * @param {FilterManager} manager - The Filter manage
     */
    function Filter($filter, manager) {
      var filter = this;
      filter.$input = $filter;
      filter.tagGroup = $filter.data('tag');
      filter.filterValue = $filter.val();
      filter.open_now = filter.tagGroup === "open_now";
      filter.open_till_9 = filter.tagGroup === "open_till_9";
      filter.open_sundays = filter.tagGroup === "open_sundays";

      // Construct the filter's badge with a button to remove the filter
      filter.$element = $('<div class="store__selected-filter">' + filter.filterValue + '</div>');
      filter.$remove = $('<button class="store__selected-filter-close"></button>');
      filter.$remove.appendTo(filter.$element);

      // Notify the manager of request to add or remove the filer
      filter.$input.on('change', function () {
        if (filter.$input[0].checked) {
          manager.attach(filter);
        } else {
          manager.detach(filter);
        }
      });
      filter.$remove.on('click', function () {
        manager.detach(filter);
      });

      // When removing the filter ensure to uncheck the input
      filter.deactive = function () {
        filter.$input.prop('checked', false);
        filter.$element.detach();
      };

      // Modify filter settings based on the state of this filter
      filter.addSetting = function (settings) {
        if (filter.$input[0].checked) {
          var tag = filter.tagGroup;
          if (filter.open_now) {
            settings["open_now"] = true;
          } else if (filter.open_till_9 || filter.open_sundays) {
            var openingDate;

            // Parse the existing time or create a new one
            if (settings.open_at) {
              openingDate = new Date(Date.parse(settings.open_at));
            } else {
              openingDate = new Date();
              openingDate.setHours(12);
              openingDate.setMinutes(0);
              openingDate.setSeconds(0);
            }

            // Set the time to 8:59 for open till 9pm
            // or add the number of days to make the date Sunday for open sunday
            if (filter.open_till_9) {
              openingDate.setHours(20);
              openingDate.setMinutes(59);
              openingDate.setSeconds(0);
            } else {
              var daysToAdd = 7 - openingDate.getDay();
              openingDate.setDate(openingDate.getDate() + daysToAdd);
            }

            settings.open_at = openingDate.toUTCString();
          } else if (tag) {
            // Check if we need to initialize the array for this tag
            if (!settings[tag]) {
              settings[tag] = [];
            }
            settings[tag].push(filter.filterValue);
          }
        }

        return settings;
      };
    }

    Store_locator.prototype.refreshMap = function () {
      var store_locator = this;

      // Trigger the resize event so that google maps will recalculate bounds
      google.maps.event.trigger(window.theme.map, 'resize');
      if (store_locator.storeBounds) {
        window.theme.map.fitBounds(store_locator.storeBounds, store_locator.fitBoundsPadding);
      }
    };

    // Toggle the visibility of the map
    Store_locator.prototype.toggleMap = function () {
      var store_locator = this;

      if (this.$mapToggleButton.hasClass('active')) {
        store_locator.$container.removeClass("map_stowed");
        this.$mapContainer.slideDown(function () {
          store_locator.refreshMap();
        });
      } else {
        this.$mapContainer.slideUp(function () {
          store_locator.$container.addClass("map_stowed");
        });
      }
    };

    Store_locator.prototype.getRadius = function () {
      return this.$filterRadius.filter(':checked')[0];
    };

    // Get a list of selected filters
    Store_locator.prototype.gatherFilters = function () {
      return this.filtersManager.filters.reduce(function (accumulator, currentValue) {
        return currentValue.addSetting(accumulator);
      }, {});
    };

    // Request a geo location from the browser's geolocation feature
    Store_locator.prototype.geolocate = function () {
      this.$locationNearby.html(this.defaultNearbyLocation);
      if (theme.cart_json.attributes.location) {
        try {
          var customer_location = JSON.parse(theme.cart_json.attributes.location);
          this.geolocateResponse(customer_location);
        } catch (e) {}
      } else {

        // Maxmind's API call
        geoip2.city(function (geolocation) {
          $.post('/cart/update.js', { 'attributes[location]': JSON.stringify(geolocation) }, function (cart) {}, 'json').done(function (cart) {
            theme.cart_json = cart;
            if (geolocation) {
              store_locator.geolocateResponse(geolocation);
            } else {
              store_locator.loadStores();
            }
          });
        }, function (error) {
          console.log(error);
          store_locator.loadStores();
        });
      }
    };

    // Set the position based on the browser's geolocation response
    Store_locator.prototype.geolocateResponse = function (position) {
      this.position = {
        latitude: position.location.latitude,
        longitude: position.location.longitude
      };

      this.loadStores();
    };

    // Set the position based on Google's geocoding response
    Store_locator.prototype.geocodeResponse = function (response) {
      if (response.status !== "OK") {
        return;
      }

      this.position = {
        latitude: response.results[0].geometry.location.lat,
        longitude: response.results[0].geometry.location.lng
      };

      this.loadStores();
    };

    // Use Google geocoding to convert the user's search
    // query into coordinates
    Store_locator.prototype.geocode = function () {
      var store_locator = this;

      var params = {
        address: store_locator.$addressLookup.val(),
        key: store_locator.key,
        region: "ca"
      };

      if (params.address == "") {
        $('.js-store-search-result').addClass('store__view-header--invalid');
        return;
      } else {
        $('.js-store-search-result').removeClass('store__view-header--invalid');
        store_locator.$locationNearby.text(params.address);
      }

      var apiUrl = window.theme.filter_map_results ? 'https://maps.googleapis.com/maps/api/geocode/json?components=country:CA&' : 'https://maps.googleapis.com/maps/api/geocode/json?';

      var settings = {
        async: true,
        url: apiUrl + $.param(params),
        method: "GET",
        dataType: "json"
      };

      return $.ajax(settings).done(function (response) {
        store_locator.geocodeResponse(response);
      });
    };

    Store_locator.prototype.filterStores = function (stores) {
      return stores.filter(function (store) {
        return store.support_in_store_pickup;
      });
    };

    // Load a list of stores from the SI endpoint
    Store_locator.prototype.loadStores = function () {
      var store_locator = this;

      var params = {};

      if (store_locator.position) {
        params.location = {};

        params.location.longitude = store_locator.position.longitude;
        params.location.latitude = store_locator.position.latitude;

        var radius = store_locator.getRadius();

        if (radius) {
          params.location.radius = radius.value;
          params.location.units = "km";
        }
      }

      $.extend(params, store_locator.gatherFilters());

      var settings = {
        "async": true,
        "url": "/apps/api/v1/stores?" + $.param(params),
        "method": "GET",
        "cache": false
      };

      return $.ajax(settings).done(function (response) {
        if (store_locator.storepicker) {
          store_locator.stores = store_locator.filterStores(response.stores);
        } else {
          store_locator.stores = response.stores;
        }

        store_locator.$resultsCount.html(store_locator.stores.length);
        store_locator.$resultsCountContainer.show();
        store_locator.pagination.setupPagination(store_locator.stores.length);
        store_locator.pagination.updatePagination(1);
      });
    };

    // Render a page of stores
    Store_locator.prototype.renderPage = function (page) {
      var store_locator = this;

      if (!store_locator.stores) {
        return;
      }

      // Remove all markers and labels
      store_locator.removeMapObjects(store_locator.markers);
      store_locator.removeMapObjects(store_locator.labels);

      store_locator.markers = [];
      store_locator.labels = [];

      var storesObject = [];
      var storeBounds = new google.maps.LatLngBounds();
      var pageindex = (page - 1) * store_locator.countPerPage;

      store_locator.stores.slice(pageindex, pageindex + store_locator.countPerPage).forEach(function (store, index) {

        var storeId = pageindex + index;

        // Add a marker at the store's position on the map
        var marker = new google.maps.Marker({
          position: { lat: store.address.latitude, lng: store.address.longitude },
          title: store.address.name.trim(),
          map: window.theme.map,
          icon: {
            url: window.theme.store_view_oval,
            size: new google.maps.Size(17, 20),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(8, 20)
          },
          label: {
            text: (index + 1).toString(),
            color: "white",
            fontSize: "10px",
            fontWeight: "600",
            fontFamily: "Montserrat"
          }
        });

        store_locator.markers.push(marker);

        // Add a label for the store's name on the map
        var label = new MapLabel({
          align: "left",
          position: new google.maps.LatLng({ lat: store.address.latitude, lng: store.address.longitude }),
          map: window.theme.map,
          text: store.address.name.trim(),
          fontColor: "black",
          fontSize: "10px",
          fontFamily: "Montserrat",
          strokeWeight: 0
        });

        var current_hours = '';

        if (!store.temporarily_closed) {
          current_hours = store_locator.processHours(store.open_hours);
        } else {
          current_hours = window.theme.strings.store_locator.temporarily_closed;
        }

        store_locator.labels.push(label);

        // Add the store coordinates to the bounds
        storeBounds.extend({ lat: store.address.latitude, lng: store.address.longitude });

        storesObject.push('<div class="store__list' + (store.temporarily_closed ? ' store__list--temporarily-closed' : '') + '"><div class="store__list-inner">');

        store.checkout_auto_fill = "&locale=" + window.theme.locale + '&step=contact_information';

        storesObject.push('<div class="store__list-upper">');
        storesObject.push('<div class="store__list-address-cell">');
        storesObject.push('<span class="store__list-oval" data-index="');
        storesObject.push(index + 1);
        storesObject.push('"><img src="');
        storesObject.push(window.theme.store_view_oval);
        storesObject.push('" alt="' + window.theme.strings.store_locator.bubble_alt + " " + (index + 1) + '"/></span>');

        storesObject.push('<h3 class="store__list-title">');
        storesObject.push(store.brand);
        storesObject.push('</h3>');
        storesObject.push('<h3 class="store__list-title store__list-title--name">');
        storesObject.push(store.address.name.trim());
        storesObject.push('</h3>');

        storesObject.push('<div class="store__list-address">');
        storesObject.push('<div>');
        storesObject.push(store.address.line1);
        storesObject.push('<br />');
        storesObject.push(store.address.line2);
        storesObject.push('</div>');
        storesObject.push('<div>');
        storesObject.push(store.address.city);
        storesObject.push(', ');
        storesObject.push(store.address.state_code);
        storesObject.push(' ');
        storesObject.push(store.address.zip);
        storesObject.push('</div>');
        storesObject.push('</div>');
        storesObject.push('</div>');

        if (store_locator.storepicker) {
          storesObject.push('<div class="store__list-pick-container">');
          storesObject = storesObject.concat(store_locator.generatePickButton(storeId));
          storesObject.push('</div>');
        }

        storesObject.push('</div>');

        storesObject.push('<div class="store__list-lower">');
        storesObject.push('<div class="store__list-hours-container">');
        storesObject.push('<h4 class="store__list-hours-title">');
        storesObject.push(window.theme.strings.store_locator.store_hours);
        storesObject.push('</h4>');
        storesObject.push('<div class="store__list-hours">');
        storesObject = storesObject.concat(current_hours);
        storesObject.push('</div>');
        storesObject.push('</div>');

        storesObject.push('<div class="store__list-links">');
        storesObject.push('<div class="store__list-phone">');
        if (store.phone) {
          storesObject.push('<a href="tel:+1');
          storesObject.push(store.phone.replace(/\D/g, ''));
          storesObject.push('">');
          storesObject.push(store.phone);
          storesObject.push('</a>');
        }
        storesObject.push('</div>');

        storesObject.push('<div class="store__list-directions">');
        storesObject.push('<a href="https://www.google.com/maps/dir/?api=1&');
        storesObject.push($.param({
          destination: [store.address.line1, store.address.line2, store.address.city, store.address.zip].join(' ')
        }));
        storesObject.push('" target="_blank">');
        storesObject.push(window.theme.strings.store_locator.directions);
        storesObject.push('</a>');
        storesObject.push('</div>');
        storesObject.push('</div>');
        storesObject.push('</div>');

        storesObject.push('</div><div class="store__list-pick-container--mobile">');
        storesObject = storesObject.concat(store_locator.generatePickButton(storeId));
        storesObject.push('</div></div>');
      });

      if (store_locator.stores.length > 0) {
        // Set the map to show the stores
        store_locator.storeBounds = storeBounds;

        if (store_locator.stores.length > 1) {
          window.theme.map.fitBounds(storeBounds, store_locator.fitBoundsPadding);
        } else {
          window.theme.map.panTo(storeBounds.getCenter());
          window.theme.map.setZoom(17);
        }
      }

      // Populate the store list container with the stores
      store_locator.$storeListContainer.html(storesObject.join(''));
    };

    /**
     * Converts a list of opening hours to html elements that are grouped by days with the same
     * opening hours
     *
     * @param {object[]} hours - A list of opening and closing hours for each day of the week
     * @returns {object[]} A list of strings representing the constructed DOM elements
     */
    Store_locator.prototype.processHours = function (hours) {
      var store_locator = this;
      var hourGrouping = [];
      var hourOutput = [];
      var opening_hours;

      // The endpoint from SI starts on Sunday, move that day
      // to the end so that we start on Monday
      if (hours[0].day === "Sunday") {
        opening_hours = hours.slice(1);
        opening_hours.push(hours[0]);
      } else {
        opening_hours = hours;
      }

      // Iterate through each day of the week
      opening_hours.forEach(function (day, index) {
        if (index === 0) {
          hourGrouping.push({ start: day });
          return;
        }

        // Get the previously inserted day
        var lastDay = hourGrouping[hourGrouping.length - 1];

        // If the previous day has the same opening hours, set it ending today,
        // else create a new time range starting today
        if (lastDay.start.open_time === day.open_time && lastDay.start.close_time === day.close_time) {
          lastDay.end = day;
        } else {
          hourGrouping.push({ start: day });
        }
      });

      // Construct the DOM elements for the time ranges
      hourGrouping.forEach(function (day) {
        hourOutput.push('<div>');
        hourOutput.push(window.theme.dayMap[window.theme.locale][day.start.day]);

        if (day.end) {
          hourOutput.push(' - ');
          hourOutput.push(window.theme.dayMap[window.theme.locale][day.end.day]);
        }

        hourOutput.push(': ');
        hourOutput = hourOutput.concat(store_locator.processAMPM(day.start.open_time));
        hourOutput.push(' - ');
        hourOutput = hourOutput.concat(store_locator.processAMPM(day.start.close_time));
        hourOutput.push('</div>');
      });

      return hourOutput;
    };

    /**
     * Convert 24 hour time to DOM elements in am/pm format for
     * english
     *
     * @param {number} time - 24 hour time
     * @returns {string[]} list of constructed DOM strings
     */
    Store_locator.prototype.processAMPM = function (time) {
      var ampmOutput = [];
      var times = time.split(':');

      if (window.theme.locale === "en-CA") {
        var hour = parseInt(times[0]);

        if (hour > 12) {
          ampmOutput.push(hour - 12);
        } else if (hour === 0) {
          ampmOutput.push('12');
        } else {
          ampmOutput.push(hour);
        }

        if (parseInt(times[1]) > 0) {
          ampmOutput.push(':');
          ampmOutput.push(times[1]);
        }

        ampmOutput.push('<sub>');
        if (hour < 12 || hour === 24) {
          ampmOutput.push('am');
        } else {
          ampmOutput.push('pm');
        }
        ampmOutput.push('</sub>');
      } else {
        ampmOutput.push(parseInt(times[0]));
        ampmOutput.push('h');

        if (parseInt(times[1]) > 0) {
          ampmOutput.push(times[1]);
        }
      }

      return ampmOutput;
    };

    /**
     * Removes the Map from a list of Google Map objects
     *
     * @param {object} objects - A list of Google Map objects
     */
    Store_locator.prototype.removeMapObjects = function (objects) {
      objects.forEach(function (element) {
        element.setMap(null);
      });
    };

    Store_locator.prototype.generatePickButton = function (store_id) {
      var buttonOutput = [];
      buttonOutput.push('<button class="store__list-pick-button js-pick-store" data-store-id="');
      buttonOutput.push(store_id);
      buttonOutput.push('">');
      buttonOutput.push(window.theme.strings.store_locator.pick_up);
      buttonOutput.push('</button>');

      return buttonOutput;
    };

    return Store_locator;
  }();

  if (window.store_locator_loader) {
    window.store_locator_loader.done(function () {
      window.store_locator = new Store_locator();
      window.store_map_loaded.resolve();
      window.store_locator.geolocate();
    });
  }
});
!function ($) {
  // Wrap any iFrame in the description to be responsive
  $('#toggle-product__description').find('iframe').filter(function (i, element) {
    return !$(element).parent().hasClass('video-container');
  }).wrap('<div class="video-container"></div>');
}(jQuery);

(function ($) {
  $(function () {
    var $videos = $('.js-video');

    // Play/pause on click (desktop only)
    $videos.each(function () {
      var $video = $(this);
      var video = $video.get(0);

      if (!video.paused) {
        $video.parent().addClass('paused');
      }

      $(this).on('click', function () {
        if (video.paused) {
          video.play();
          $video.parent().removeClass('paused');
        } else {
          video.pause();
          $video.parent().addClass('paused');
        }
      });
    });
  });
})(jQuery);
(function ($) {
  $(function () {
    $('.flipdown').each(function () {
      var timer = $(this).data('flipdown');
      new FlipDown(timer, $(this).attr('id')).start();
    });
  });
})(jQuery);

/*================ Templates ================*/
!function (theme, $) {
  function loadTests() {
    var params = theme.utils.getURLParams();

    if (params.ab && theme.cart_json.attributes._ab !== params.ab) {
      var data = {
        attributes: {
          _ab: params.ab
        }
      };

      $.post('/cart/update.js', data, 'json');
    }
  }

  // Function only for test 2 A/B testing
  // Delete after use.
  (function () {
    if ((theme.cart_json.attributes._ab == 'test2' || theme.utils.getURLParams().ab == 'test2') && (!theme.utils.getURLParams().ab || theme.utils.getURLParams().ab == 'test2')) {
      $('#product__description').detach().appendTo('.product__atc-container');
      $('.product__selector-container').addClass('product__selector-container--alt');
      // Reverse tabs
      console.log('Reverse!');
      $('[data-for="#toggle-product__description"]').detach().appendTo('.product__description-toggle-menu');
    } else if (theme.cart_json.attributes._ab == 'test2' && theme.utils.getURLParams().ab && theme.utils.getURLParams().ab != 'test2') {
      // Revert to pre-test
      var $container = $('<div class="grid">' + '<div class="grid__item large-up--two-thirds">' + '<div class="grid">' + '<div class="grid__item large-up--push-one-sixth large-up--five-sixths product__description-container"></div>' + '</div>' + '</div>').appendTo('.product__page-container');

      $('#product__description').detach().appendTo($container.find('.product__description-container'));
      $('.product__selector-container').removeClass('product__selector-container--alt');
      $('[data-for="#toggle-product__description"]').detach().prependTo('.product__description-toggle-menu');
    }
  })();

  // On load function
  loadTests();
}(window.theme = window.theme || {}, jQuery);

!function (promoMessaging, $) {
  var prod_messaging = {};
  var campaigns = window.CAMPAIGN_MESSAGING || [];

  var getMessages = function getMessages() {
    return $('[data-promo-message]');
  };
  // Promo messaging object
  var promoMessage = function promoMessage(config) {
    var promoMessage = this;
    var config = config || {};

    var setPromo = function setPromo() {
      for (var i = 0; i < campaigns.length; i++) {
        var campaign = campaigns[i];
        if (campaign.hasOwnProperty('include') && campaign.include.hasOwnProperty('collection_includes') && campaign.hasOwnProperty('display_messaging') && !campaign.include.hasOwnProperty('discount_code') && campaign.display_messaging) {
          var collection = campaign.include.collection_includes;
          var exclusion = campaign.exclude && campaign.exclude.collection_includes ? campaign.exclude.collection_includes : false;

          if (promoMessage.collections.indexOf(collection) >= 0 && promoMessage.collections.indexOf(exclusion) < 0) {
            var promo_object = {
              regular_priced: campaign.regular_priced_only,
              messaging: campaign.message,
              type: campaign.type,
              colors: campaign.colors,
              calculate_price: campaign.calculate_price
            };

            if (campaign.discount) {
              var amount = campaign.discount.match(/\(([\d|\.]+)\)/)[1];
              promo_object.discount = {
                amount: parseFloat(amount),
                type: campaign.discount.split('Discount')[0].toLowerCase()
              };
            }

            return promo_object;
          }
        }
      }
      return false;
    };

    promoMessage.collections = config.collections || [];
    promoMessage.id = config.id;
    promoMessage.sale = config.sale || false;
    promoMessage.promo = setPromo();
  };

  // Update promo message based on element
  promoMessaging.showMessages = function () {
    $.each(prod_messaging, function (id, promoMessage) {
      if (promoMessage.promo && !(promoMessage.sale && promoMessage.promo.regular_priced)) {
        var $message = $('.messaging-' + promoMessage.id);

        $message.html('<span class="promo-message" ' + (promoMessage.promo.colors ? 'style="background-color: ' + promoMessage.promo.colors.background + ';color: ' + promoMessage.promo.colors.text + '"' : '') + '>' + promoMessage.promo.messaging + '</span>');

        if (promoMessage.promo.calculate_price) {
          var $price = $message.closest('.js-product').find('.js-product-price');
          var price = $price.data('product-price');

          // Convert the price if it's a string
          if (!!price && typeof price !== 'number') {
            price = price.match(/\d+/g).join('');
          }

          try {
            var old_price = parseFloat(price / 100);
            var new_price = old_price;

            switch (promoMessage.promo.discount.type) {
              case 'percentage':
                new_price = old_price - old_price * (promoMessage.promo.discount.amount / 100);
                break;
              case 'money':
                new_price = old_price - promoMessage.promo.discount.amount;
                break;
              case 'price':
                new_price = promoMessage.promo.discount.amount;
                break;
            }

            new_price = Math.ceil(new_price * 100) / 100;
            if (!$price.find('.discounted').length && old_price > new_price) {
              $price.html('<span class="sale-wrapper">' + $price.html().trim() + '<span class="discounted">' + theme.utils.toMoney(new_price) + '</span></span>');
            }
          } catch (e) {}
        }
      }
    });
  };

  promoMessaging.addMessage = function ($element, config) {
    if (!prod_messaging[config.id]) {
      prod_messaging[config.id] = new promoMessage(config);
    }
    // Add class for selection
    $element.addClass('messaging-' + config.id);
  };

  // Update the list of products
  promoMessaging.update = function () {
    var deferred = [];

    getMessages().each(function () {
      var $this = $(this);
      var config = $this.data('promo-message');
      config.id = config.product || Math.floor(Math.random() * 1000000);

      if (config && config.collections !== undefined) {
        promoMessaging.addMessage($this, config);
      } else if (config.handle || config.url) {
        var handle = !!config.handle ? config.handle : config.url.split('products/')[1].split('?')[0];

        // Fetch the product data
        if (handle && !prod_messaging[config.product]) {
          deferred.push(promoMessaging.getPromo(handle).done(function (resp) {
            // Test to make sure the proper data is sent back
            var regEx = /^\n<!doctype html>/;

            if (regEx.test(resp)) {
              return false;
            }
            try {
              var object = JSON.parse(resp);
              promoMessaging.addMessage($this, object);
            } catch (e) {
              return false;
            }
          }));
        } else {
          promoMessaging.addMessage($this, config);
        }
      }
    });

    // Show messages on elements
    $.when.apply($, deferred).always(function () {
      promoMessaging.showMessages();
    });
  };
  promoMessaging.getProductMessages = function () {
    return prod_messaging;
  };

  promoMessaging.getPromo = function (handle) {
    return $.get('/products/' + handle + '?view=collections');
  };

  $(function () {
    promoMessaging.update();
  });
}(window.promoMessaging = window.promoMessaging || {}, jQuery);
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
}();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
}();

/**
 * Register Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Register template.
 *
 */

function validatePassword() {
  if ($('#CreatePassword').val() != $('#ConfirmPassword').val()) {
    $('#ConfirmPassword')[0].setCustomValidity('Passwords must match.');
    return false;
  } else {
    $('#ConfirmPassword')[0].setCustomValidity('');
  }
  return true;
}

$('form#create_customer').submit(function (e) {
  if (!validatePassword()) {
    e.preventDefault();
  }
});

$('#ConfirmPassword').keyup(validatePassword);
$(".expandable-tab").click(function () {
  var $tab = $(this);
  var $content = $tab.next();
  $content.slideToggle(500);
  $tab.toggleClass('toggled');
});
// Form submission handling for the gift card balance checker page
$(function () {
  var $submitBtn = $("#card-balance-form-submit");
  var $reloadBtn = $("#card-balance-form-reload");
  var $cardForm = $('#card-balance-form');
  var $responseContainer = $('#gift-card-message');

  $cardForm.submit(function (e) {
    e.preventDefault();

    $submitBtn.prop('disabled', true);

    var VERIFY_CARD_URL = '/apps/api/v1/check_gift_card_balance';

    $responseContainer.hide().empty().removeClass('text-danger');

    $.post({
      url: VERIFY_CARD_URL,
      data: $(this).serialize(),
      dataType: 'json'
    }).done(function (r) {
      $responseContainer.slideDown().html(r.message);
      $cardForm.slideUp();
      $reloadBtn.slideDown();
    }).fail(function (r) {
      if (r.responseJSON) {
        $responseContainer.slideDown().html(r.responseJSON.message.split("-")[0].replace('gift_card_code', 'card number').replace('pin_number', 'pin number')).addClass('text-danger');
      } else if (r.status === 404) {
        $responseContainer.slideDown().html("Error connecting to server").addClass('text-danger');
      }
    }).always(function () {
      $submitBtn.prop('disabled', false);
    });
  });

  $reloadBtn.click(function (e) {
    $cardForm[0].reset();
    $cardForm.slideDown();
    $reloadBtn.slideUp();
    $responseContainer.slideUp();
  });

  $submitBtn.prop('disabled', false);
});
!function (tile, $) {
  // Returns HTML of a product tile
  tile.render = function (product, classes) {
    if (!product) return false;

    var productObject = [];
    var colorOption = product.options.find(function (option) {
      return ['color', 'colour', 'couleur', 'coloures'].indexOf(option.name.toLowerCase()) >= 0;
    });
    var lower_tags = product.tags.map(function (tag) {
      return theme.utils.handleize(tag.toLowerCase());
    });
    var availableVariants = product.variants.filter(isAvailable);
    var firstAvailableVariant = availableVariants[0];
    var cart_ids = document._shopify_cart.cart.line_items.map(function (item) {
      return item.product_id;
    });
    var english_product = product.tags.indexOf('language_en') > -1 ? product.handle : product.metafields && product.metafields.translate && product.metafields.translate['en-CA'] ? product.metafields.translate['en-CA'] : false;

    function isAvailable(variant) {
      return variant.inventory_policy != 'deny' || variant.inventory_quantity > 0 ? true : false;
    }

    if (!product.type || product.type && product.type.handleize() != 'gift-card') {
      var promo_data = {
        product: product.id,
        sale: product.compare_at_price && product.compare_at_price > product.price,
        handle: product.handle
      };
      if (product.collections) {
        promo_data.collections = product.collections;
      }
      var $promo_message = $('<div class="promo-message-container"></div>').attr('data-promo-message', JSON.stringify(promo_data));
    }

    // Default product tile classes
    if (!classes) {
      classes = "grid__item one-fifth medium--one-quarter small--one-half product-list__item";
    }

    var gift_card_class = "";
    if (product.type == "Gift Card") {
      gift_card_class = 'product-tile--gift-card';
    }

    productObject.push('' + '<li data-product="' + product.id + '" class="js-product ' + classes + '">' + '<div class="featured-collection__info js-product-tile ' + gift_card_class + '">' + '<div class="product-tile-image" data-cart-badge="' + product.id + '">');

    if (window.theme.badges) {
      var overlay_class = '';

      if (window.theme.badges.trending && lower_tags.indexOf('trending') > -1) {
        productObject.push('<div class="badge-container"><img class="product-badge" src="' + window.theme.badges.trending + '"></div>');
      } else if (window.theme.badges.sale && lower_tags.indexOf('sale') > -1) {
        productObject.push('<div class="badge-container"><img class="product-badge" src="' + window.theme.badges.sale + '"></div>');
      }

      if (window.theme.badges.musthaves && lower_tags.indexOf('musthaves') > -1) {
        productObject.push('<div class="badge-container badge-container--secondary"><img class="product-badge" src="' + window.theme.badges.musthaves + '"></div>');
      }

      if (window.theme.badges.musthaves && lower_tags.indexOf('preorder') > -1) {
        productObject.push('<div class="badge-container badge-container--tertiary"><img class="product-badge" src="' + window.theme.badges.preorder + '"></div>');
      }

      // Chooses if the urban kid badge/plus size should be diplayed as an overlay badge or as simple badge
      if (lower_tags.indexOf('trending') > -1 || lower_tags.indexOf('sale') > -1) {
        overlay_class = 'badge-overlay';
      }

      if (window.theme.badges.plus && lower_tags.indexOf('fit-plus-size') > -1) {
        productObject.push('<div class="badge-container ' + overlay_class + '"><img class="product-badge" src="' + window.theme.badges.plus + '"></div>');
      } else if (window.theme.badges.kids && lower_tags.indexOf('brand-urban-kids') > -1) {
        productObject.push('<div class="badge-container ' + overlay_class + '"><img class="product-badge" src="' + window.theme.badges.kids + '"></div>');
      }
    }

    productObject.push('' + '<a href="' + (window.theme && window.theme.template && window.theme.template == 'collection' ? window.location.pathname : '') + product.url + '">' + '<img class="featured_collection__image" src="' + slate.Image.getSizedImageUrl(product.featured_image || window.theme.placeholder, '270x400_crop_center') + '" alt="' + product.title + '">' + '</a>');

    if (cart_ids.indexOf(product.id) > -1 && window.theme.badges && window.theme.badges.cart) {
      productObject.push('<img class="product-badge badge-cart" src="' + window.theme.badges.cart + '">');
    }

    productObject.push('' + '</div>' + (english_product ? '<div class="featured-collection__quick-shop-anchor">' + '<div class="quick-add js-quick-add" data-quick-add="' + english_product + '" data-quick-add-display="' + product.handle + '"></div>' + '</div>' : '') + '<a class="featured-collection__info" href="' + (window.theme && window.theme.template && window.theme.template == 'collection' ? window.location.pathname : '') + product.url + '" alt="' + product.title + '">' + '<h2 class="featured-collection__product-title">' + product.title + '</h2>' + '</a>' + '<p class="featured-collection__product-price js-product-price" data-product-price="' + product.price + '">' + (product.compare_at_price && product.compare_at_price > product.price ? '<span class="grid-item-compare">' + slate.Currency.formatMoney(product.compare_at_price) + '</span>' + '<span class="grid-item-sale">' + theme.strings.now + ' ' + slate.Currency.formatMoney(product.price) + '</span>' : '<span class="grid-item-price">' + (product.price_varies ? window.theme.strings.product.from.replace('{{ price }}', slate.Currency.formatMoney(product.price)) : '<span class="grid-item-price">' + slate.Currency.formatMoney(product.price) + '</span>') + (product.available == false && product.type != "Gift Card" ? '<span class="grid-item-sold-out">' + window.theme.strings.product.sold_out + '</span>' : '') + '</span>') + '</p>' + '<div class="selector-wrapper js product__option-selector">');

    if (product.metafields && product.metafields.color_filters && product.metafields.color_filters.images) {
      var colors = product.metafields.color_filters.images.split(',').map(function (color) {
        var color_split = color.split('%%%');
        return {
          name: (color_split[0] && color_split[0]) == '' ? false : color_split[0],
          image: (color_split[1] && color_split[1]) == '' ? false : color_split[1]
        };
      }).filter(function (color) {
        return color.name && color.image && product.variants.some(function (variant) {
          return variant['option' + colorOption.position] == color.name;
        });
      });

      $.each(colors, function (index, color) {
        var matchesColor = function matchesColor(variant) {
          return color.name === variant['option' + colorOption.position];
        };

        if (availableVariants.some(matchesColor)) {
          var color_handle = window.theme.utils.handleize(color.name);
          var inputId = product.id + '-' + color_handle + '-' + window.getNextCounter();
          var isChecked = color.name === firstAvailableVariant['option' + colorOption.position] ? 'checked' : '';
          productObject.push('' + '<input class="swatch-radio js-quick-add-color" type="radio" id="' + inputId + '" name="' + product.id + '-color" value="' + color.name + '" data-index="option' + colorOption.position + '"' + isChecked + '>' + '<label title="' + color.name + '" class="product__radio radio-color swatch-' + color_handle + '" for="' + inputId + '" data-variant-image="' + slate.Image.getSizedImageUrl(color.image || window.theme.placeholder, '270x400_crop_center') + '"></label>');
        }
      });
    }

    productObject.push('' + '</div>' + '</div>' + '</li>');

    var $product_tile = $(productObject.join(''));
    $product_tile.prepend($promo_message);

    // Initialize the quick add functionality
    new theme.QuickAdd($product_tile);

    return $product_tile;
  };
}(window.tile = window.tile || {}, jQuery);
$(".reorder__move-up, .reorder__move-down").click(function () {
  var row = $(this).parents("tr:first");
  if ($(this).is(".reorder__move-up")) {
    row.insertBefore(row.prev());
  } else {
    row.insertAfter(row.next());
  }
});

$(".giftreggie-permalink").focus(function () {
  var $this = $(this);
  $this.select();

  // Work around Chrome's little problem
  $this.mouseup(function () {
    // Prevent further mouseup intervention
    $this.unbind("mouseup");
    return false;
  });
});
// account registration
$(function () {
  function formValidation($form, message) {
    if (!$form || !message) return false;

    $form.find('.validation').slideUp(function () {
      $(this).remove();
    });

    $('<span style="display:none" class="validation">' + message + '</span>').insertAfter($form.find('input[type="submit"]').first()).slideDown();
  }

  $('#create_customer, #customer_login').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
    var customerQuery = {
      email: $form.find('[name="customer[email]"]').val(),
      email_body: '',
      language: 'lang_' + window.theme.language
    };

    $.post('/apps/api/v1/query_import_customer', customerQuery, function (resp) {
      if (resp.imported_customer == 'true') {
        formValidation($form, window.theme.strings.account.account_already_exists);
        return false;
      } else {
        $form.off().submit();
      }
    }).fail(function (resp) {
      $form.off().submit();
    });
  });
});
$(document).ready(function () {

  var $size_guide_modal = $('.js-sg-modal');
  var $size_guide_content = $('.js-sg-modal-content');
  var $size_guide_open = $('.js-sg-open-modal');
  var $size_guide_close = $('.js-sg-close-modal');

  $size_guide_open.click(function () {
    $($(this).data('modal-target')).addClass('open');
    $size_guide_content.scrollTop(0);
  });

  $size_guide_close.click(function () {
    $(this).closest('.js-sg-modal').removeClass('open');
  });

  $(window).click(function (e) {
    if ($(e.target).hasClass('js-sg-modal')) {
      var id = '#' + $(event.target).attr('id');
      $(id).removeClass('open');
    }
  });
});
!function (sticky, $) {
  // DOM elements
  var elements = [];
  var $window = $(window);
  var window_width = $window.width();

  var element = function element($elem, options) {
    var _ = this;
    var options = options || {};

    // Calculate if disabled based on min and max breakpoints to stick
    var isDisabled = function isDisabled() {
      return options.max && options.max < window_width || options.min && options.min > window_width;
    };

    _.selector = $elem;
    _.offset = Math.max($elem.offset().top - $(document).scrollTop(), 0);
    _.stuck = false;
    _.disabled = isDisabled();

    _.stick = function () {
      _.stuck = true;
      _.selector.addClass('sticky');
    };
    _.unstick = function () {
      _.stuck = false;
      _.selector.removeClass('sticky');
    };

    _.update = function () {
      if (_.disabled) return false;
      $(document).scrollTop() > _.offset ? _.stick() : _.unstick();
    };

    // Refresh values after window resize and update
    _.refresh = function () {
      _.offset = Math.max($elem.offset().top - $(document).scrollTop(), 0);
      _.disabled = isDisabled();
      if (_.disabled) _.unstick();
      _.update();
    };
  };

  sticky.refresh = function (element) {
    $.each(elements, function (index, element) {
      element.refresh();
    });
  };

  sticky.update = function (element) {
    $.each(elements, function (index, element) {
      element.update();
    });
  };

  sticky.getElems = function () {
    return elements;
  };

  // Initialize
  $('[data-sticky]').each(function () {
    elements.push(new element($(this), $(this).data('sticky')));
  });

  $(document).scroll(function () {
    sticky.update(elements);
  });

  $(window).resize(function () {
    window_width = $window.width();
    sticky.refresh(elements);
  });

  sticky.update(elements);
}(window.sticky = window.sticky || {}, jQuery);
(function (theme) {
  var QuickAdd = function QuickAdd($element) {
    if (!$element) {
      return false;
    }

    $element = $element.is('[data-quick-add]') ? $element : $element.find('[data-quick-add]').first();

    var _ = this;

    this.elements = {
      container: $element,
      parent_container: $element.closest('.js-quick-add-container'),
      tile: $element.closest('.js-product-tile')
    };
    this.elements.product = this.elements.tile.closest('.js-product');
    this.elements.form = this.elements.tile.find('form[action="/cart/add"]');

    this.promo_data = $('[data-promo-message]', this.elements.product).data('promo-message');

    this.product_handle = $element.data('quick-add');
    this.display_product_handle = $element.data('quick-add-display');
    this.separate_display_product = this.display_product_handle && this.display_product_handle !== this.product_handle;

    this.loaded = false;

    // Build the element
    var string_text = this.elements.parent_container.hasClass('featured-collection__quick-shop-anchor--pre-order') ? theme.strings.quickview.preOrder : theme.strings.quickview.label;
    this.elements.button = $('<button class="quick-add-button" type="button"><span>' + string_text + '</span><span class="quick-add-icon">+</span></button>').click(function () {
      _.open();
    }).appendTo(this.elements.container);

    // Save color selector and bind change event
    this.elements.colors = this.elements.tile.find('.js-quick-add-color').change(function () {
      var $this = $(this);
      _.selected_color = {
        value: $this.val(),
        name: $this.data('name')
      };
      if (_.loaded) {
        _.updateOptions();
      }
    });

    // Return to the quickview button 5 seconds after mouse out
    this.elements.tile.on('mouseleave', function () {
      _.closing = true;

      setTimeout(function () {
        if (_.closing) {
          _.close();
        }
      }, 5000);
    });
    // If a mouse enter occurs in the mean time, cancel closing
    this.elements.tile.on('mouseenter', function () {
      _.closing = false;
    });
  };

  // Returns an array of the selected variants, matching the passed options as an object
  QuickAdd.prototype.selectedVariants = function (options) {
    return this.product.variants.filter(function (variant) {
      return (options.option1 ? variant.option1 == options.option1 : true) && (options.option2 ? variant.option2 == options.option2 : true) && (options.option3 ? variant.option3 == options.option3 : true);
    });
  };

  // Returns the matching variant option between the display and added product
  // Example, if option1 is the color, pass "1" and "Blanc" to get "White" for the English product
  QuickAdd.prototype.getMatchingOption = function (option_position, option_value) {
    var _ = this;
    var variant_sku = _.display_product.variants.filter(function (variant) {
      return variant['option' + option_position] == option_value;
    })[0].sku;
    return _.product.variants.filter(function (variant) {
      return variant.sku == variant_sku;
    })[0]['option' + option_position];
  };

  // Build the form, bind all elements
  QuickAdd.prototype.buildOptions = function () {
    var _ = this;

    this.elements.form = $('<form action="/cart/add" method="post" enctype="multipart/form-data" class="quick-add-atc"><span class="quick-add-label">' + theme.strings.quickview.atc + '</span></form>').submit(function (event) {
      event.preventDefault();
      if (_.elements.atc_error) {
        _.elements.atc_error.slideUp(function () {
          $(this).remove();
        });
      }
      var form_data = $(this).serialize();
      window.Cart.addItem(form_data).done(function (response) {
        window.Cart.openCart();
      }).fail(function (response) {
        console.warn('QuickAdd: Failed to add to cart.', response);
        _.elements.atc_error = $('<span class="quick-add-error" style="display:none">' + theme.strings.addingFail + '</span>').appendTo(_.elements.form).slideDown();
      });
    });

    // Add the hidden options for add to cart
    var $hidden_inputs = $();
    this.elements.id = $('<input type="hidden" name="id">');
    $.each(this.display_product.options, function (index, option) {
      if (option) {
        var option_key = 'option' + option.position;
        _.elements[option_key + '_title'] = $('<input type="hidden" name="properties[_option_title' + option.position + ']" value="' + option.name + '">');
        _.elements[option_key + '_value'] = $('<input type="hidden" name="properties[_' + option_key + ']">');
        $hidden_inputs = $hidden_inputs.add(_.elements[option_key + '_title']).add(_.elements[option_key + '_value']);
      }
    });

    var product_promotion_messages = promoMessaging.getProductMessages()[this.display_product.id] || {};
    var _product_promotion_me = product_promotion_messages.collections,
        collectionHandleArray = _product_promotion_me === undefined ? [] : _product_promotion_me;


    $hidden_inputs.add(this.elements.id).add($('<input type="hidden" name="properties[_url]" value="' + this.display_product.url + '">')).add($('<input type="hidden" name="properties[_title]" value="' + this.display_product.title + '">')).add($('<input type="hidden" value="Tile" name="properties[_added_from]">')).add($('<input type="hidden" value="' + collectionHandleArray.join(',') + '" name="properties[_collection_ids]">')).appendTo(this.elements.form);

    this.elements.option_container = $('<div class="quick-add-options"></div>').appendTo(this.elements.form);
    this.elements.options = $();

    // Create an element for each size
    $.each(this.size_option.values, function (index, size_name) {
      var size_value = _.separate_display_product ? _.getMatchingOption(_.size_option.position, size_name) : size_name;

      // Create the input
      var $option = $('<button type="button" class="quick-add-size" value="' + size_value + '" data-name="' + size_name + '">' + size_name + '</button>').click(function () {
        // Build the variant options
        var selected_options = {};
        var $this = $(this);
        var size = $this.val();
        var name = $this.data('name');
        if (_.color_option) {
          selected_options['option' + _.color_option.position] = _.selected_color.value;
        }
        selected_options['option' + _.size_option.position] = $this.val();

        // Find the variant
        var variant = _.selectedVariants(selected_options)[0];

        // Set the hidden inputs on the form
        _.elements.id.val(variant.id);
        // Color
        if (_.color_option) {
          _.elements['option' + _.color_option.position + '_value'].val(_.selected_color.name);
        }
        // Size
        _.elements['option' + _.size_option.position + '_value'].val(name);

        _.elements.form.submit();
      });

      _.elements.options = _.elements.options.add($option);
    });
    this.elements.options.appendTo(this.elements.option_container);

    // Add the quick add panel to the tile
    this.elements.container.append(this.elements.form);

    // Update the options with available sizes
    if (this.display_product.options.length > 1) {
      _.updateOptions();
    }
  };

  QuickAdd.prototype.setDisplayProduct = function (product) {
    if (!product) {
      return false;
    }

    this.display_product = product;

    // Set the size option
    var size_names = ['size', 'grandeur', 'values', 'valeur'];
    this.size_option = this.display_product.options.filter(function (option) {
      return size_names.indexOf(theme.utils.handleize(option.name)) !== -1;
    })[0];

    // Set the color option
    var color_names = ['color', 'couleur', 'colour'];
    this.color_option = this.display_product.options.filter(function (option) {
      return color_names.indexOf(theme.utils.handleize(option.name)) !== -1;
    })[0];
  };

  QuickAdd.prototype.setProduct = function (product) {
    if (!product) {
      return false;
    }

    this.product = product;
  };

  QuickAdd.prototype.load = function () {
    var _ = this;
    var deferred_calls = [];
    this.elements.button.find('.quick-add-icon').replaceWith('<i class="quick-add-load fa fa-spinner fa-spin" aria-hidden="true"></i>');

    // Display another product but add an English product to cart
    if (_.separate_display_product) {
      deferred_calls.push($.get('/products/' + _.display_product_handle + '.js', function (product) {
        _.setDisplayProduct(product);
      }, 'json'));
    }

    deferred_calls.push($.get('/products/' + _.product_handle + '.js', function (product) {
      _.setProduct(product);
      if (!_.separate_display_product) {
        _.setDisplayProduct(product);
      }
    }, 'json'));

    // Return when the AJAX chain is complete.
    // Multilingual has multiple products to AJAX.
    return $.when.apply(undefined, deferred_calls).then(function () {

      _.elements.colors.each(function () {
        var $this = $(this);
        var color = $this.val();

        // Update the color values to match with English
        if (_.separate_display_product) {
          var new_color = _.getMatchingOption(_.color_option.position, color);
          $this.val(new_color);
        }

        $this.data('name', color);
      });

      var $selected_color = _.elements.colors.filter(':checked');
      _.selected_color = {
        value: $selected_color.val(),
        name: $selected_color.data('name')
      };

      _.buildOptions();

      // Mark product as loaded
      _.elements.button.find('.quick-add-load').replaceWith('<span class="quick-add-icon">+</span></button>');
      _.loaded = true;
    });
  };

  QuickAdd.prototype.open = function () {
    var _ = this;

    if (this.loaded) {
      this.elements.container.addClass('quick-add-open');
    } else {
      this.load().then(function () {
        _.elements.container.addClass('quick-add-open');
      });
    }
  };

  QuickAdd.prototype.close = function () {
    this.elements.container.removeClass('quick-add-open');
    if (this.elements.atc_error) {
      this.elements.atc_error.slideUp(function () {
        $(this).remove();
      });
    }
  };

  // Updates size options
  QuickAdd.prototype.updateOptions = function () {
    var _ = this;

    // Generate the options
    var selected_options = {};
    selected_options['option' + this.color_option.position] = this.selected_color.value;

    // Find matching variants
    var selected_variants = this.selectedVariants(selected_options);
    // Create an array of available sizes only
    var available_sizes = selected_variants.filter(function (variant) {
      return variant.available && variant.featured_image;
    }).map(function (variant) {
      return variant['option' + _.size_option.position];
    });

    // Disable options that are not in the list of available sizes
    this.elements.options.each(function () {
      if (available_sizes.indexOf($(this).val()) > -1) {
        $(this).prop('disabled', false);
      } else {
        $(this).prop('disabled', true);
      }
    });
  };

  // Initialize all quick adds on the page
  $(function () {
    $('.js-quick-add').each(function () {
      new QuickAdd($(this));
    });
  });

  theme.QuickAdd = QuickAdd;
})(window.theme = window.theme || {}, jQuery);

$(document).ready(function () {

  var modal_element = document.getElementById('newsletter-footer-modal');

  if (!modal_element) {
    return;
  }

  var modal = new theme.Modal(modal_element, {});
  var $newsletter_interface = $('.js-newsletter-form');
  var $open_modal_button = $('.js-modal-newsletter-button');
  var $submit_button = $('.js-submit-newsletter-button');
  var $brand_checkbox = $('.js-newsletter-checkbox');
  var $newsletter = $('#newsletter-footer-modal');

  $brand_checkbox.prop('checked', true);

  // Closes the newsletter modal interface
  $newsletter.on('modal.hide', function () {

    var $form = $newsletter.find('.js-newsletter-form');
    var $submit_button = $newsletter.find('.js-submit-newsletter-button');
    var $errors = $form.find('.js-newsletter-errors');
    var $success = $form.find('.js-newsletter-success');

    $form[0].reset();
    $submit_button.addClass('disabled');
    $errors.hide();
    $success.hide();
  });

  // Opens the newsletter modal interface
  $open_modal_button.on('click', function () {

    var $newsletter_panel = $(this).closest('.js-newsletter-panel');
    var email = $newsletter_panel.find('.js-newsletter-panel-email').val();
    var $form = $newsletter.find('.js-newsletter-form');
    var $errors = $form.find('.js-newsletter-errors');
    var $success = $form.find('.js-newsletter-success');

    $success.hide();
    $errors.hide();
    $brand_checkbox.prop('checked', true);
    $form.find('input[name="email"]').val(email);
    modal.show();
  });

  // Submits the user's requested
  // newsletter subscriptions
  $submit_button.click(function (e) {
    e.preventDefault();
    var $form = $(this).closest('.js-newsletter-form');
    var $user_email = $form.find('input[name="email"]');
    var $errors = $form.find('.js-newsletter-errors');
    var $success = $form.find('.js-newsletter-success');
    var $brand_list = $form.find('.js-newsletter-brands');
    var selected_brands = $brand_list.find('input[type="checkbox"]:checked');
    var $klaviyo_email_inputs = $('.js-klavio-user-email');

    if (theme.utils.isEmail($user_email.val())) {
      $klaviyo_email_inputs.val($user_email.val()); // Populates all of the Klaviyo forms with the user's email
      formSwitch(selected_brands); // Sends the Klaviyo forms based on the selected brands
      $errors.hide();
      $success.show();
      $user_email.hide();
    } else {
      $errors.empty();
      $success.hide();
      erroDisplay($errors, $user_email);
    }
  });

  // Validates the fields needed to add
  // on the newsletters subscription form
  $newsletter_interface.each(function () {
    var $this = $(this);
    var $submit_btn = $this.find('.js-submit-newsletter-button');
    var $email = $this.find('input[name="email"]');
    var $csal = $this.find('input[name="casl"]');
    var $brands = $this.find('input[type="checkbox"]');

    $this.on('change', function () {
      var csal = $csal.prop('checked') ? true : undefined;
      var $selected_brand = $brands.filter(':checked');

      if (csal && $email.val() && $selected_brand.length > 0) {
        $submit_btn.removeClass('disabled');
      } else {
        $submit_btn.addClass('disabled');
      }
    });
  });

  // Filters the Klaviyo forms and send only
  // the one that we're selected by the user
  function formSwitch(selected_brands) {
    selected_brands.each(function () {
      var id = '#' + $(this).val() + "-newsletter-form";
      $(id).submit();
    });
  }

  function erroDisplay($error_container, $error_field) {
    var $item = $('<p>', { class: 'newsletter-form__message' });
    $error_container.append($item.text($error_field.data('form-error')));
    $error_container.show();
  }
});

(function ($) {
  var nostojs = window.nostojs || false;

  if (!nostojs) {
    var name = "nostojs";
    window[name] = window[name] || function (cb) {
      (window[name].q = window[name].q || []).push(cb);
    };
    nostojs = window.nostojs;
  }

  function updateNostoPromos() {
    nostojs(function (api) {
      api.listen('postrender', function (nostoPostRenderEvent) {
        if (!!promoMessaging) {
          promoMessaging.update();
        }
      });
    });
  }

  $(function () {
    if (!!nostojs) {
      updateNostoPromos();
    }
  });
})(jQuery);

var SpotUI = function (_FiltersUI) {
  _inherits(SpotUI, _FiltersUI);

  function SpotUI(engine, container) {
    _classCallCheck(this, SpotUI);

    var _this13 = _possibleConstructorReturn(this, (SpotUI.__proto__ || Object.getPrototypeOf(SpotUI)).call(this, engine));

    _this13.container = container;

    _this13.resultsContainer = document.querySelector('.js-filter-products');
    _this13.resultsRenderer = new ProductRenderer();
    _this13.paginationRenderer = new PaginationRenderer();

    _this13.init();

    _this13.container.addEventListener('change', _this13.updateFilter.bind(_this13));
    _this13.container.addEventListener('reset', $.debounce(50, _this13.updateFilter.bind(_this13)));
    return _this13;
  }

  _createClass(SpotUI, [{
    key: 'init',
    value: function init() {
      var _this14 = this;

      _get(SpotUI.prototype.__proto__ || Object.getPrototypeOf(SpotUI.prototype), 'init', this).call(this);
      this.isInfinite = false;
      this.initPagination();
      this.engine.pageSize = 48;
      switch (theme.template.name) {
        case 'search':
          this.engine.search = theme.current_object.terms;
          break;
        case 'collection':
          this.engine.collection = theme.current_object.handle;
          break;
      }
      this.engine.getResults().then(function (r) {
        _this14.renderFilters(_this14.engine.options);
        _this14.renderSorting();
        _this14.renderPages({
          count: _this14.engine.count,
          page: _this14.engine.page,
          pageCount: _this14.engine.pageCount
        });
        if (_this14.engine.filters.some(function (filter) {
          return filter.state.length;
        })) {
          _this14.renderActiveFilters();
          _this14.filter();
        } else {
          _this14.renderResults(_this14.engine.results);
        }
      });
    }
  }, {
    key: 'initFilters',
    value: function initFilters() {
      var filters = [];
      this.container.querySelectorAll('[data-filter-type]').forEach(function (element) {
        switch (element.dataset.filterType) {
          case 'option':
            filters.push(new OptionFilter(element, element.dataset.filterKey, JSON.parse(element.dataset.filterValues)));
            break;
          case 'price':
            filters.push(new PriceFilter(element, element.dataset.filterKey, JSON.parse(element.dataset.filterValues)));
            break;
          default:
            filters.push(new SimpleFilter(element, element.dataset.filterKey, JSON.parse(element.dataset.filterValues)));
            break;
        }
      });
      return filters;
    }
  }, {
    key: 'initSorting',
    value: function initSorting() {
      var sorting = [];
      this.container.querySelectorAll('[data-sorting]').forEach(function (element) {
        var sortOptions = [];
        element.querySelectorAll('[name="filter-sort"]').forEach(function (option) {
          sortOptions.push(option.value);
        });
        sorting.push(new SimpleFilter(element, 'sorting', sortOptions));
      });
      return sorting;
    }
  }, {
    key: 'initPagination',
    value: function initPagination() {
      var _this15 = this;

      var viewAll = document.querySelectorAll('.js-view-all');
      viewAll.forEach(function (button) {
        return button.addEventListener('click', function (event) {
          event.preventDefault();
          if (_this15.engine.page !== 1) {
            _this15.resultsContainer.innerHTML = '';
            _this15.engine.page = 1;
          }
          _this15.isInfinite = !_this15.isInfinite;
          viewAll.forEach(function (button) {
            return button.classList[_this15.isInfinite ? 'add' : 'remove']('active');
          });
          document.querySelectorAll('.js-filter-paginate').forEach(function (element) {
            element.classList[_this15.isInfinite ? 'add' : 'remove']('infinite');
          });
          window[_this15.isInfinite ? 'addEventListener' : 'removeEventListener']('scroll', _this15.scrollHandler);
          _this15.filter();
        });
      });

      this.scrollHandler = $.debounce(50, function () {
        var scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
        var bottom = _this15.resultsContainer.offsetTop + _this15.resultsContainer.offsetHeight - scrollTop - window.innerHeight;
        if (bottom < window.innerHeight) {
          window.removeEventListener('scroll', _this15.scrollHandler);
          _this15.engine.page = _this15.engine.page + 1;
          _this15.filter();
        }
      });

      if (this.isInfinite) {
        window.addEventListener('scroll', this.scrollHandler);
      }

      document.querySelectorAll('.pagination-button-prev').forEach(function (button) {
        return button.addEventListener('click', function (event) {
          _this15.engine.page = _this15.engine.page - 1;
          _this15.filter();
          event.preventDefault();
        });
      });
      document.querySelectorAll('.pagination-button-next').forEach(function (button) {
        return button.addEventListener('click', function (event) {
          _this15.engine.page = _this15.engine.page + 1;
          _this15.filter();
          event.preventDefault();
        });
      });

      $('.pagination-button-prev, .pagination-button-next, .js-view-all', '.pagination-bottom').on('click', function () {
        $('body, html').animate({ scrollTop: 0 }, 1000);
      });
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this16 = this;

      this.engine.saveState();
      this.engine.getResults().then(function (r) {
        _this16.renderResults(_this16.engine.results);
        _this16.renderPages({
          count: _this16.engine.count,
          page: _this16.engine.page,
          pageCount: _this16.engine.pageCount
        });
        if (_this16.isInfinite && _this16.engine.page < _this16.engine.pageCount) {
          window.addEventListener('scroll', _this16.scrollHandler);
        }
      });
    }
  }, {
    key: 'updateFilter',
    value: function updateFilter() {
      this.renderActiveFilters();
      this.engine.currentPage = 1;
      this.filter();
    }
  }, {
    key: 'renderFilters',
    value: function renderFilters(filters) {
      var _this17 = this;

      filters.forEach(function (values, index) {
        _this17.engine.filters[index].renderOptions(values.option || values);
      });
      return filters;
    }
  }, {
    key: 'renderActiveFilters',
    value: function renderActiveFilters(filters) {
      var container = document.querySelector('.js-filter-breadcrumbs');
      if (container) {
        var options = this.engine.filters.reduce(function (array, facet) {
          return array.concat(facet.renderActiveOptions());
        }, []);
        container.classList[options.length ? 'remove' : 'add']('filter-breadcrumbs--empty');
        container.querySelector('.filter-breadcrumbs-target').innerHTML = options.join('');
      }
      return filters;
    }
  }, {
    key: 'renderSorting',
    value: function renderSorting() {
      this.engine.sorting.forEach(function (sort) {
        sort.element.querySelectorAll('input').forEach(function (input) {
          return input.checked = sort.state.indexOf(input.value) > -1;
        });
      });
      return this.engine.sorting;
    }
  }, {
    key: 'renderPages',
    value: function renderPages(pages) {
      this.paginationRenderer.render(pages);
      return pages;
    }
  }, {
    key: 'renderResults',
    value: function renderResults(results) {
      if (!this.isInfinite) {
        this.resultsContainer.innerHTML = '';
      }
      $(this.resultsContainer).append(this.resultsRenderer.render(results));
      window.promoMessaging.update();
      return results;
    }
  }, {
    key: 'isInfinite',
    get: function get() {
      return this.view_mode == 'append';
    },
    set: function set(flag) {
      this.view_mode = flag ? 'append' : 'replace';
    }
  }]);

  return SpotUI;
}(FiltersUI);

var OptionFilter = function (_SimpleFilter) {
  _inherits(OptionFilter, _SimpleFilter);

  function OptionFilter(element, key, values) {
    _classCallCheck(this, OptionFilter);

    var _this18 = _possibleConstructorReturn(this, (OptionFilter.__proto__ || Object.getPrototypeOf(OptionFilter)).call(this, element, key, values));

    if (_this18.element.dataset.labelRender == 'swatch') {
      _this18.renderer = new SwatchFilterRenderer(_this18);
    }
    return _this18;
  }

  _createClass(OptionFilter, [{
    key: 'getOptionConfig',
    value: function getOptionConfig() {
      return { option: this.key };
    }
  }, {
    key: 'apply',
    value: function apply(query) {
      var _this19 = this;

      var values = this.getActiveOptions().reduce(function (options, option) {
        var value = _this19.values.find(function (value) {
          return value.name === option;
        });
        return options.concat(value ? value.value : option);
      }, []);
      if (values.length) {
        query.option(this.key, 'in', values);
      }
      return query;
    }
  }]);

  return OptionFilter;
}(SimpleFilter);

var SwatchFilterRenderer = function (_FilterRenderer) {
  _inherits(SwatchFilterRenderer, _FilterRenderer);

  function SwatchFilterRenderer(filter) {
    _classCallCheck(this, SwatchFilterRenderer);

    return _possibleConstructorReturn(this, (SwatchFilterRenderer.__proto__ || Object.getPrototypeOf(SwatchFilterRenderer)).call(this, filter));
  }

  _createClass(SwatchFilterRenderer, [{
    key: 'renderLabel',
    value: function renderLabel(label) {
      return '<span class="product__radio radio-color swatch-' + theme.utils.handleize(label) + '"></span>' + label;
    }
  }]);

  return SwatchFilterRenderer;
}(FilterRenderer);

var PriceFilter = function (_SimpleFilter2) {
  _inherits(PriceFilter, _SimpleFilter2);

  function PriceFilter() {
    _classCallCheck(this, PriceFilter);

    return _possibleConstructorReturn(this, (PriceFilter.__proto__ || Object.getPrototypeOf(PriceFilter)).apply(this, arguments));
  }

  _createClass(PriceFilter, [{
    key: 'getOptionConfig',
    value: function getOptionConfig() {
      return { price: this.values.map(function (value) {
          return value.value;
        }) };
    }
  }, {
    key: 'apply',
    value: function apply(query) {
      var _this22 = this;

      var values = this.getActiveOptions().reduce(function (options, option) {
        var value = _this22.values.find(function (value) {
          return value.name === option;
        });
        return options.concat(value ? value.value : option);
      }, []);
      if (values.length) {
        var sets = [];
        values.forEach(function (value) {
          var set = [];
          value.split('-').forEach(function (step, index) {
            if (!isNaN(step.replace(/\D/g, ''))) {
              set.push([index ? '<' : '>=', step.replace(/\D/g, '')]);
            }
          });
          sets.push(set);
        });
        if (sets.length <= 1) {
          sets.forEach(function (set) {
            return set.forEach(function (step) {
              return query.price.apply(query, step);
            });
          });
        } else {
          query.or.apply(query, sets.map(function (set) {
            return set.map(function (step) {
              var subquery = new SpotAPI().s();
              return subquery.price.apply(subquery, step);
            });
          }).map(function (set) {
            var subquery = new SpotAPI().s();
            return subquery.and.apply(subquery, set);
          }));
        }
      }
      return query;
    }
  }]);

  return PriceFilter;
}(SimpleFilter);

var ProductRenderer = function (_Renderer2) {
  _inherits(ProductRenderer, _Renderer2);

  function ProductRenderer() {
    _classCallCheck(this, ProductRenderer);

    return _possibleConstructorReturn(this, (ProductRenderer.__proto__ || Object.getPrototypeOf(ProductRenderer)).call(this));
  }

  _createClass(ProductRenderer, [{
    key: 'render',
    value: function render(results) {
      return _get(ProductRenderer.prototype.__proto__ || Object.getPrototypeOf(ProductRenderer.prototype), 'render', this).call(this, results).map(this.renderItem);
    }
  }, {
    key: 'renderItem',
    value: function renderItem(product) {
      return window.tile.render(product, 'grid__item one-fifth medium--one-quarter small--one-half product-list__item');
    }
  }]);

  return ProductRenderer;
}(Renderer);

var PaginationRenderer = function (_Renderer3) {
  _inherits(PaginationRenderer, _Renderer3);

  function PaginationRenderer() {
    _classCallCheck(this, PaginationRenderer);

    return _possibleConstructorReturn(this, (PaginationRenderer.__proto__ || Object.getPrototypeOf(PaginationRenderer)).call(this));
  }

  _createClass(PaginationRenderer, [{
    key: 'render',
    value: function render(_ref2) {
      var count = _ref2.count,
          page = _ref2.page,
          pageCount = _ref2.pageCount;

      document.querySelectorAll('.js-filter-count').forEach(function (element) {
        return element.textContent = count;
      });
      document.querySelectorAll('.pages__current').forEach(function (element) {
        return element.textContent = page;
      });
      document.querySelectorAll('.pages__total').forEach(function (element) {
        return element.textContent = pageCount;
      });

      var previous = page > 1 ? page - 1 : null;
      var next = page < pageCount ? page + 1 : null;
      document.querySelectorAll('.pagination-button-prev').forEach(function (button) {
        return button.href = previous ? window.location.href + '?page=' + previous : '';
      });
      document.querySelectorAll('.pagination-button-next').forEach(function (button) {
        return button.href = next ? window.location.href + '?page=' + next : '';
      });
    }
  }]);

  return PaginationRenderer;
}(Renderer);

document.querySelectorAll('[data-spot-init]').forEach(function (element) {
  var spotParams = {
    hostname: [theme.shop.permanent_domain],
    count: [true, 'exact'],
    index: [0],
    allVariants: [false],
    available: [true],
    fields: [['id', 'handle', 'title', 'product_type', 'vendor', 'tags', 'image', 'images', 'options', 'variants', 'collections', 'metafields']]
  };
  var spotResource = new SpotResource(new SpotAPI(JSON.parse(element.dataset.spotInit)), spotParams);
  window.spotFilters = new SpotUI(new FiltersEngine(spotResource), element);
});

var SpotInstant = function (_FiltersUI2) {
  _inherits(SpotInstant, _FiltersUI2);

  function SpotInstant(engine, container) {
    _classCallCheck(this, SpotInstant);

    var _this25 = _possibleConstructorReturn(this, (SpotInstant.__proto__ || Object.getPrototypeOf(SpotInstant)).call(this, engine));

    _this25.container = container;

    _this25.resultsContainer = document.querySelector('.search__content-output');
    _this25.resultsRenderer = new ProductRenderer();
    _this25.init();

    var inputs = document.querySelectorAll('.search-form [name="q"]');
    var view_alls = _this25.container.querySelectorAll('.js-search-all');
    var clears = _this25.container.querySelectorAll('.js-search-clear');
    var search_toggles = document.querySelectorAll('[data-search-toggle]');

    clears.forEach(function (clear) {
      return clear.addEventListener('click', function (event) {
        event.preventDefault();
        inputs.forEach(function (input) {
          return input.value = '';
        });
        _this25.container.style.display = 'none';
        document.body.querySelector('main').style.display = '';
      });
    });

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var query = input.value.trim();
        inputs.forEach(function (i) {
          if (i != input) {
            i.value = query;
          }
        });
        view_alls.forEach(function (anchor) {
          return anchor.href = '/search?q=' + query;
        });
        if (query.length < 2) {
          _this25.container.style.display = 'none';
          document.body.querySelector('main').style.display = '';
          return;
        }
        _this25.engine.search = query;
        _this25.filter();
        _this25.container.style.display = '';
        document.body.querySelector('main').style.display = 'none';
      });
    });

    search_toggles.forEach(function (search_toggle) {
      search_toggle.addEventListener('click', function (event) {
        var search_form = event.target.closest('form');
        $(search_form.querySelector('.js-search-box')).slideToggle();
      });
    });
    return _this25;
  }

  _createClass(SpotInstant, [{
    key: 'init',
    value: function init() {
      _get(SpotInstant.prototype.__proto__ || Object.getPrototypeOf(SpotInstant.prototype), 'init', this).call(this);
      this.engine.pageSize = 12;
    }
  }, {
    key: 'filter',
    value: function filter() {
      var _this26 = this;

      this.engine.getResults().then(function (r) {
        _this26.renderResults(_this26.engine.results);
      });
    }
  }, {
    key: 'renderResults',
    value: function renderResults(results) {
      this.resultsContainer.innerHTML = '';
      $(this.resultsContainer).append(this.resultsRenderer.render(results));
      window.promoMessaging.update();
      return results;
    }
  }]);

  return SpotInstant;
}(FiltersUI);

document.querySelectorAll('[data-spot-instant]').forEach(function (element) {
  var spotParams = {
    hostname: [theme.shop.permanent_domain],
    count: [true, 'exact'],
    index: [0],
    allVariants: [false],
    available: [true],
    fields: [['id', 'handle', 'title', 'product_type', 'vendor', 'tags', 'image', 'images', 'options', 'variants', 'collections', 'metafields']]
  };
  var spotResource = new SpotResource(new SpotAPI(JSON.parse(element.dataset.spotInstant)), spotParams);
  window.spotInstant = new SpotInstant(new FiltersEngine(spotResource), element);
});

(function (theme, $) {

  // Set the warehouse location to east
  $(function () {
    if (!theme.cart_json.attributes.warehouse_region) {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { 'attributes[warehouse_region]': 'East' },
        dataType: 'json'
      }).done(function (cart) {
        theme.cart_json = cart;
      });
    }
  });
})(window.theme = window.theme || {}, jQuery);
(function (theme) {

  if (!theme.stockNotifications) {
    return;
  }

  var popup_modal = new theme.Modal(document.getElementById('stock-info-modal'), {});
  var variant_modal = new theme.Modal(document.getElementById('stock-variant-modal'), {});
  var success_modal = new theme.Modal(document.getElementById('stock-success-modal'), {});
  var $subscribe_button = $('.js-stock-subscribe-button');
  var $stock_newsletter = $('.js-stock-newsletter');
  var $cart_button = $('.js-add-to-cart');
  var $notification_form = $('#stock-notification-form');
  var $newsletter_form = $('#stock-newsletter-form');

  if (!window.localStorage.getItem('stockNotificationPopup')) {
    popup_modal.show();
    window.localStorage.setItem('stockNotificationPopup', true);
  }

  $(document).on('variantChange', function (e) {
    var variant = e.variant;
    var product = theme.current_object;
    var $variant_tile = $('.js-stock-variant-tile');
    var $options = $variant_tile.find('.js-stock-variant-options');
    var $klaviyo_variant = $('.js-klavio-stock-variant');

    if (!variant) {
      return;
    }

    $klaviyo_variant.val(variant.id); // Assigns the variant id that will be sent to the klaviyo subscription
    $variant_tile.find('.js-stock-variant-title').text(product.title);
    $variant_tile.find('.js-stock-variant-image').attr('src', variant.featured_image.src);

    // Displays the selected variant's options
    $options.empty();
    variant.options.forEach(function (option, i) {
      var li = $('<li>');
      var variant_option = product.options[i];

      li.append($('<span>', { class: 'variant-tile-options__title', text: variant_option }));
      li.append($('<span>', { class: 'variant-tile-options__value', text: ': ' + option }));
      $options.append(li);
    });
  });

  $cart_button.on('click', function (e) {
    if ($cart_button.find('.text--out-of-stock').length != 0) {
      e.preventDefault();
      variant_modal.show();
    }
  });

  $subscribe_button.on('click', function (e) {
    e.preventDefault();

    var $email = $(this).closest('.js-stock-variant').find('.js-stock-user-email');
    var $klaviyo_email = $('.js-klavio-user-email');

    if (!theme.utils.isEmail($email.val())) {
      $email.addClass('stock-subscription-input--error');
      return false;
    } else {
      $email.removeClass('stock-subscription-input--error');
      $klaviyo_email.val($email.val());
    }

    var stock_form_data = new FormData($notification_form[0]);
    var newsletter_form_data = new FormData($newsletter_form[0]);

    var settings = {
      url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
      type: 'POST',
      processData: false,
      contentType: false,
      cache: false,
      data: stock_form_data
    };

    $.ajax(settings).then(function () {
      if (!$stock_newsletter.find('input').prop('checked')) {
        return;
      }
      var settings = {
        url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        method: 'POST',
        processData: false,
        contentType: false,
        cache: false,
        data: newsletter_form_data
      };
      $.ajax(settings);
    }).done(function () {
      variant_modal.hide();
      success_modal.show();
    });
  });
})(theme = window.theme || {}, jQuery);

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);
  sections.register("cart", theme.Cart);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
  }

  //Custom dropdown functionality
  $('.dropdown').click(function () {
    $(this).toggleClass('active');
    $('.dropdown__option').click(function () {
      $('.dropdown__button').html($(this).data('value'));
    });
  });

  //Set custom dropdown default value
  if ($('.dropdown__button').text() == "") {
    var $defaultOption = $('.dropdown').find('.dropdown__option').first().data('value');
    $('.dropdown__button').html($defaultOption);
  }

  //Close dropdown if clicking anywhere else on the page
  window.onclick = function (event) {
    if (!$(event.target).is('.dropdown, .dropdown *') && $('.dropdown').hasClass('active')) {
      $('.dropdown').removeClass('active');
    }
  };

  //Update language selection as cart attribute
  $('[data-switch-locale]').off('click').on('click', function (e) {
    e.preventDefault();
    var redirect_url = this.href;
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        'attributes[locale]': $(this).data('switch-locale'),
        'attributes[brand]': window.theme.brand
      },
      dataType: 'json'
    }).always(function () {
      window.location.href = redirect_url;
    });
  });

  // Initialize collection grid masonry layout
  $(".collection-grid").masonry({
    itemSelector: '.collection-grid__item-outer',
    columnWidth: '.grid-sizer',
    gutter: '.gutter-sizer',
    percentPosition: true
  });
});

//
// Replay Queued jQuery
//
$.each(window.__jqReady || [], function (index, f) {
  if (typeof f === 'function') {
    $(f);
  } else {
    console.warn('non function jquery call before jquery loaded', f);
  }
});

// Load all sliders, remap and masonry
$(function () {
  var initialize = function initialize() {
    $('.slick').slick();
  };

  initialize();

  $(document).on('shopify:section:load', function () {
    initialize();
  });

  // Use class 'remap' to responsively map images
  $('.remap').rwdImageMaps();
});

function getUrlVars() {
  var vars = [],
      hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}